import React, { useEffect, useState, lazy, Suspense } from "react";
import Footer from "../../Components/Footer/footer";
import performRequest from "../../api/request";
import { Toast } from "../../CustomComponent/toast";
import LoadingPage from "../../Components/layouts/loading";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router";
import getFilteredURL from "../../Components/Functions/filters.getUrl";
import { LeadInfo } from "../../SchemaInfo/info";
import SimpleButton from "../../Components/layouts/simple_button";
import { CustomErrorResponse } from "../../CustomComponent/custom_error_response";
import CustomViewButton from "../../CustomComponent/custom_view_button";
import Cookies from "js-cookie";
import { Formik, Form } from "formik";
import { HydroponicMaterialInfo } from "../../SchemaInfo/info";
// import { AddItemHydroponicMaterial } from "../../../Schemas/Farm support/farmer_inventory_schema";
import { AddItemHydroponicMaterial } from "../../../Kryzen Alpha App/Schemas/Farm support/farmer_inventory_schema";
// import CustomInput from "../../../CustomComponent/custom_input";
import CustomInput from "../../CustomComponent/custom_input";
import CustomSelect from "../../CustomComponent/custom_select";
import FormSubmitButton from "../../Components/layouts/formSubmitButton";

import {
  FcCustomerSupport,
  FcCallback,
  FcSignature,
  FcWorkflow,
  FcRules,
  FcRatings,
  FcLandscape,
} from "react-icons/fc";
import { IoInformationCircleOutline } from "react-icons/io5";

import { MdLogin, MdLogout, MdChecklist, MdPayment } from "react-icons/md";
import SalesDailyReport from "./salesDailyReport";
import MediaTaskTable from "../Media And Marketing/Media Delivery/media_delivery_table";
import Pagination from "../../Components/layouts/pagination";
import AlphaDailyCallRecords from "./alphaDailyCallRecords";

const FarmConstructionAgreement = lazy(() =>
  import("../Farm Management/farm_construction_agreement")
);

const EmployeeWorkData = lazy(() =>
  import("./Dashbourd Components/employee_daily_work")
);
const AttendanceTracking = lazy(() =>
  import("./Dashbourd Components/attendance_tracking")
);

const LeaderBoard = lazy(() =>
  import("./Dashbourd Components/dashboard_leaderboard")
);
const SalesWorkTracking = lazy(() =>
  import("./Dashbourd Components/sales_work_tracking")
);

const getTaskListDetails = (task = []) => {
  let totalTasks = task.length;
  let completedTasks = task?.filter((t) => t.isUpdated || t.isNotApplicable);
  return `${completedTasks.length}/${totalTasks}`;
};
const getTaskCompleteProgress = (task = []) => {
  let totalTasks = task.length;
  let completedTasks = task?.filter((t) => t.isUpdated || t.isNotApplicable);
  let width = (completedTasks.length / totalTasks) * 100 || 0;
  return `${width}%`;
};
const getTaskCompleteCount = (task = []) => {
  let completedTasks = task?.filter((t) => t.isUpdated || t.isNotApplicable);
  return completedTasks.length;
};
const getName = (lead) => {
  if (lead.fullName) {
    return lead.fullName;
  }
  if (lead.firstName && lead.lastName) {
    return `${lead.firstName} ${lead.lastName}`;
  }
  if (lead.firstName) {
    return lead.firstName;
  }
  if (lead.lastName) {
    return lead.lastName;
  }
  return "N/A";
};

const Dashbourd = () => {
  const months = [
    { name: "January", value: 0 },
    { name: "February", value: 1 },
    { name: "March", value: 2 },
    { name: "April", value: 3 },
    { name: "May", value: 4 },
    { name: "June", value: 5 },
    { name: "July", value: 6 },
    { name: "August", value: 7 },
    { name: "September", value: 8 },
    { name: "October", value: 9 },
    { name: "November", value: 10 },
    { name: "December", value: 11 },
  ];

  const [selectedMonth, setSelectedMonth] = useState(new Date().getMonth());
  const store = useSelector((store) => store.login.user);
  const [currentUser, setCurrentUser] = useState(store.Name);
  const [employee, setEmployee] = useState(
    store && store.Role === process.env.REACT_APP_ROLE_ADMIN_S
      ? "All"
      : store.Name
  );
  const [employeeName, setEmployeeName] = useState(
    (store && store.Role === process.env.REACT_APP_ROLE_ADMIN_S) ||
      store.Role === process.env.REACT_APP_ROLE_ADMIN
      ? "All"
      : store.Name
  );
  const [trackFrom, setTrackFrom] = useState(0);
  const [attendanceData, setAttendanceData] = useState();
  const [projectTrackingData, setProjectTrackingData] = useState();
  const [leaveData, setLeaveData] = useState();
  const [leadOwner, setLeadOwner] = useState();
  const [tableData, setTableCount] = useState();
  const [loading, setLoading] = useState(false);
  const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());
  const [todaysData, setTodaysData] = useState();
  const [taskData, setTaskData] = useState();
  const [clientFeedback, setClientFeedback] = useState();
  const [refresh, setRefresh] = useState(false);
  const years = [2024, 2025, 2026, 2027, 2028, 2029, 2030];
  const [modalData, setModalData] = useState();
  const [taskPopUpShowed, setTaskPopUpShowed] = useState(Cookies.get("popUp"));
  const [resetPasswordShowed, setResetPasswordShowed] = useState(
    Cookies.get("resetpassmodal")
  );
  const [taskScore, setTaskScore] = useState(0);
  const [points, setPoints] = useState(0);
  const [sortedData, setsortedData] = useState([]);
  const [missedCall, setmissedCall] = useState([]);
  const [inventoryData, setInventoryData] = useState([]);
  const [inventoryThresholdData, setInventoryThresholdData] = useState(0);
  const [inventoryCountData, setInventoryCountData] = useState(0);
  const [cost, setCost] = useState([]);
  const [vendorList, setVendorList] = useState([]);
  const [marketingTask, setMarketingTask] = useState([]);
  const [page, setPage] = useState(1);
  const [showPage, setShowPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [alphaCallRecordingData, setAlphaCallRecordingData] = useState({});
  const [alphaCallRecordsTrackFrom, setAlphaCallRecordsTrackFrom] = useState(1);

  const [showInfo, setShowInfo] = useState(false);
  const navigate = useNavigate();
  const goToView = (id) => {
    navigate(`/client-feedback/new?id=${id}`);
  };
  const goToViewPendingFollwup = (id) => {
    navigate(`/leads-followup/view/${id}`);
  };
  const goToViewTaks = (id) => {
    navigate(`/task-management/view/${id}`);
  };

  const goToViewLeave = (userId) => {
    navigate(`employee-leave-management/view/${userId}`);
  };

  function formatDate(dateStr) {
    const months = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];

    const dateParts = dateStr.split("-");
    const year = dateParts[0];
    const month = parseInt(dateParts[1], 10) - 1;
    const day = parseInt(dateParts[2], 10);
    return `${day} ${months[month]} ${year}`;
  }

  function getProjectTracking() {
    performRequest("GET", "/projectTracking/getAllProjectTracking")
      .then((res) => {
        if (res.status === 200) {
          let data = res.data?.projectTrackingData
            .filter((project) =>
              project.taskList.some(
                (task) =>
                  (task.taskName === "Project Handover" ||
                    task.taskName === "Handover") &&
                  task.isUpdated !== true &&
                  task.isLocked !== true
              )
            )
            .sort((pro1, pro2) => {
              return (
                getTaskCompleteCount(pro2.taskList) -
                getTaskCompleteCount(pro1.taskList)
              );
            });
          setProjectTrackingData(data);
        } else {
          Toast("error", "Error while getting project Details!");
        }
      })
      .catch((err) => {
        CustomErrorResponse(err);
      })
      .finally(() => setLoading(false));
  }

  function getLeadOwners() {
    performRequest("GET", "/leads/getAllLeadsOwners")
      .then((res) => setLeadOwner(res?.data))
      .catch((err) => CustomErrorResponse(err));
  }
  function getLeavesData() {
    performRequest("GET", `/leave/getDashboardLeaves/`)
      .then((res) => {
        if (res.status === 200) {
          setLeaveData(res.data.leave);
        } else {
          Toast("error", "Error while getting Attendance!");
        }
      })
      .catch((err) => {
        CustomErrorResponse(err);
      })
      .finally(() => setLoading(false));
  }
  function getAllTablesData() {
    performRequest("GET", "/allTablesCount/getCount")
      .then((res) => {
        if (res.status === 200) {
          setTableCount(res.data);
        } else {
          Toast("error", "Error while getting project Details!");
        }
      })
      .catch((err) => {
        CustomErrorResponse(err);
      });
  }
  function getAssignFeedback() {
    performRequest("GET", "/allTablesCount/getAssignedFeedback")
      .then((res) => {
        if (res.status === 200) {
          setClientFeedback(res.data);
        } else {
          Toast("error", "Error while getting project Details!");
        }
      })
      .catch((err) => {
        CustomErrorResponse(err);
      })
      .finally(() => setLoading(false));
  }
  function getAttendanceByEmployeeName(employeeName) {
    if (employeeName === "All") {
      performRequest("GET", `/attendance/getAllAttendance`)
        .then((res) => {
          if (res.status === 200) {
            setAttendanceData(res.data);
          } else {
            Toast("error", "Error while getting Attendance!");
          }
        })
        .catch((err) => {
          CustomErrorResponse(err);
        })
        .finally(() => setLoading(false));
    } else {
      performRequest("GET", `/attendance/getAllAttendance?name=${employeeName}`)
        .then((res) => {
          if (res.status === 200) {
            setAttendanceData(res.data);
          } else {
            Toast("error", "Error while getting Attendance!");
          }
        })
        .catch((err) => {
          CustomErrorResponse(err);
        })
        .finally(() => setLoading(false));
    }
  }

  useEffect(() => {
    if (employeeName && store.Role !== process.env.REACT_APP_ROLE_CLIENT) {
      getAttendanceByEmployeeName(employeeName);
    }
  }, [employeeName, store.Role]);

  useEffect(() => {
    if (store.Role !== process.env.REACT_APP_ROLE_CLIENT) {
      if (
        store.Role !== process.env.REACT_APP_ROLE_SALLE &&
        store.Role !== process.env.REACT_APP_ROLE_SALLE_ADMIN &&
        store.Role !== process.env.REACT_APP_ROLE_IT
      ) {
        getProjectTracking();
        getAssignFeedback();
      }
      getLeadOwners();
      getLeavesData();
      getAllTablesData();
    }
  }, [store.Role]);

  const setCookie = (name, value, hours) => {
    const date = new Date();
    date.setTime(date.getTime() + hours * 60 * 60 * 1000);
    const expires = "expires=" + date.toUTCString();
    document.cookie = name + "=" + value + ";" + expires + ";path=/";
  };

  useEffect(() => {
    if (store) {
      if (
        store?.DaysRemainingToUpdatePassword &&
        +store?.DaysRemainingToUpdatePassword < 0 &&
        store?.Role !== process.env.REACT_APP_ROLE_CLIENT
      ) {
        alert("your password update required!.please update it.");
        navigate("/reset-password");
        return;
      } else if (
        !taskPopUpShowed &&
        store.Role !== process.env.REACT_APP_ROLE_CLIENT
      ) {
        const btn = document.getElementById("openmodel");
        if (btn) {
          btn.click();
          setCookie("popUp", "close", 9);
        }
      }
    }
  }, [store, navigate]);

  useEffect(() => {
    if (
      store.Role !== process.env.REACT_APP_ROLE_CLIENT &&
      store.Role !== process.env.REACT_APP_ROLE_ADMIN_S
    ) {
      performRequest("GET", `/tasks/getUserPecentageById/${store.UserId}`)
        .then((res) => {
          if (res.status === 200) {
            setTaskScore(res?.data);
          } else {
            Toast("error", "Error while getting Leads!");
          }
        })
        .catch((err) => {
          CustomErrorResponse(err);
        });
    }
  }, [employee]);

  useEffect(() => {
    if (
      store.Name &&
      store.Role !== process.env.REACT_APP_ROLE_ADMIN_S &&
      store.Role !== process.env.REACT_APP_ROLE_CLIENT
    ) {
      performRequest("GET", `/tasks/getUserTodaysPointsById/${store?.UserId}`)
        .then((res) => {
          if (res.status === 200) {
            setPoints(res.data?.todaysPoints);
          }
        })
        .catch((err) => {
          CustomErrorResponse(err);
        });
    }
  }, [store.Name]);

  useEffect(() => {
    if (
      currentUser &&
      store.Role !== process.env.REACT_APP_ROLE_CLIENT &&
      store.Role !== process.env.REACT_APP_ROLE_IT
    ) {
      performRequest(
        "GET",
        getFilteredURL("/allTablesCount/getTableCountByNameNew/", 1, {
          generatedby: currentUser,
        })
      )
        .then((res) => {
          if (res.status === 200) {
            setTodaysData(res?.data);
          }
        })
        .catch((err) => {
          console.error(err);
        });
    }
  }, [currentUser, refresh]);

  // useEffect(() => {
  //   performRequest("GET", `/enquiryWebhook/getMyoperatorMisscallData`)
  //     .then((res) => {
  //       if (res.status === 200) {
  //         setmissedCall(res?.data?.groupedData);
  //       }
  //     })
  //     .catch((err) => {
  //       console.error(err);
  //     });
  // }, []);

  useEffect(() => {
    if (store.Role === process.env.REACT_APP_ROLE_MARKETING_AGENCY) {
      performRequest(
        "GET",
        getFilteredURL("/mediaDelivery/get-assignTask", page)
      )
        .then((res) => {
          if (res.status === 200) {
            setMarketingTask(res.data?.taskData);
            setTotalPages(Math.ceil(res.data?.totalCount / 50));
          } else {
            Toast("error", "Error while getting Data!");
          }
        })
        .catch((err) => {
          CustomErrorResponse(err);
        });
    }
  }, [refresh, page]);

  useEffect(() => {
    if (store.Role !== process.env.REACT_APP_ROLE_CLIENT) {
      performRequest("GET", `/tasks/getTaskManagementDashboard`)
        .then((res) => {
          if (res.status === 200) {
            setTaskData(res.data.taskManagementData);
            sortData(res.data.taskManagementData);
          } else {
            Toast("error", "Error while getting Tasks!");
          }
        })
        .catch((err) => {
          CustomErrorResponse(err);
        })
        .finally(() => setLoading(false));
    }
  }, [currentUser]);

  useEffect(() => {
    performRequest("GET", `/materialPlanning/getAllThresholdlimit`)
      .then((res) => {
        if (res.status === 200) {
          setInventoryData(res?.data?.getAllThreshold);
          setInventoryThresholdData(res?.data?.getAllThresholdCount);
          setInventoryCountData(res?.data?.getAllCount);
        } else {
          Toast("error", "Error while getting Tasks!");
        }
      })
      .catch((err) => {
        CustomErrorResponse(err);
      })
      .finally(() => setLoading(false));
  }, []);

  useEffect(() => {
    performRequest("GET", "/poDcPi/getAllVendorList")
      .then((res) => setVendorList(res.data))
      .catch((err) => CustomErrorResponse(err));
  }, []);

  const assignNewEnquires = () => {
    performRequest("GET", `/leads_v2/assign_new_enquries/`)
      .then((res) => {
        if (res.status === 200) {
          Toast("success", "New Enquires added successfully");
          setRefresh(!refresh);
        } else {
          Toast(
            "Error while getting Enquires or Enquires assigned limit exceeded"
          );
        }
      })
      .catch((err) => {
        CustomErrorResponse(err);
      });
  };

  const AddAndAssignLead = (values) => {
    let lead = {
      ...LeadInfo,
      first_name: values.firstName || values.fullName || "",
      last_name: values.lastName || "",
      interestedIn: [],
      full_name: getName(values),
      services: "",
      planned_area: "",
      location_type: "",
      company_name: values.businessName || "",
      lead_genrated_from: "enquiry",
      lead_alloted_to: store.Name || "",
      reAssignTo: store.Name || "",
      preferred_contact_method: "",
      phone_number: values.mobileNumber || values?.whatsappNumber || "",
      lead_status: "",
      email: values.email || "",
      gst_number: values.gst_number || "",
      address: values.address1 || values.address2 || "",
      notes: values.notes || "",
    };
    setLoading(true);
    performRequest("POST", "/leads/createleads", lead)
      .then((res) => {
        if (res.status === 201) {
          setTimeout(() => {
            Toast("success", "Leads generated successfully!");
            if (res.data.id) {
              navigate(`/leads/edit-lead/${res.data.id}`);
            }
          }, 500);
        } else if (res.status === 200) {
          Toast("error", res.data.message);
          if (res.data.id) {
            navigate(`/leads/edit-lead/${res.data.id}`);
          }
          setRefresh(!refresh);
        } else {
          Toast("error", "Error while uploading");
        }
      })
      .catch((err) => {
        CustomErrorResponse("Error", err);
      })
      .finally(() => setLoading(false));
  };
  const handleCall = (phoneNumber) => {
    if (phoneNumber) {
      window.location.href = `tel:${phoneNumber}`;
    } else {
      alert("Phone number is not available!");
    }
  };
  useEffect(() => {
    if (
      store?.DaysRemainingToUpdatePassword &&
      +store?.DaysRemainingToUpdatePassword < 0 &&
      store?.Role === process.env.REACT_APP_ROLE_CLIENT
    ) {
      alert("your password update required!.please update it.");
      navigate("/reset-password");
    } else if (
      !resetPasswordShowed &&
      store?.DaysRemainingToUpdatePassword &&
      store?.Role === process.env.REACT_APP_ROLE_CLIENT
    ) {
      document.getElementById("openresetpasswordmodal").click();
      setCookie("resetpassmodal", "reminded", 9);
    }
  }, [store]);

  if (loading) {
    return <LoadingPage />;
  }

  const ClassNameReturnAttendance = () => {
    let className = "col-md-12 col-lg-12";
    if (
      store.Role === process.env.REACT_APP_ROLE_ADMIN ||
      store.Role === process.env.REACT_APP_ROLE_ADMIN_S
    ) {
      className = "col-md-12 col-lg-8";
    }
    return className;
  };

  const parseDate = (dateStr) => {
    return dateStr ? new Date(dateStr) : null;
  };

  // Sorting the leaveData by date in increasing order
  const sortedLeaveData = leaveData?.sort((a, b) => {
    const dateA = parseDate(a.leaveDate) || parseDate(a.leaveStartDate);
    const dateB = parseDate(b.leaveDate) || parseDate(b.leaveStartDate);
    return dateA - dateB;
  });

  const getProgressBarColor = (score) => {
    return score >= 90
      ? "bg-success"
      : score >= 70
      ? "bg-warning"
      : "bg-danger";
  };

  const sortData = (data) => {
    const priorityOrder = { P1: 1, P2: 2, P3: 3, "": 4 };

    const pendingTasks = data
      .filter((item) => item.status === "pending")
      .sort(
        (a, b) =>
          (priorityOrder[a.priority] || 4) - (priorityOrder[b.priority] || 4)
      );

    const completedTasks = data
      .filter((item) => item.status === "completed")
      .sort(
        (a, b) =>
          (priorityOrder[a.priority] || 4) - (priorityOrder[b.priority] || 4)
      );

    setsortedData([...pendingTasks, ...completedTasks]);
  };

  const ClassNameReturnPurchase = () => {
    if (store.Role === process.env.REACT_APP_ROLE_PURCHASE) {
      return "col-sm-6 col-lg-3";
    }
    return "col-sm-6 col-lg-2";
  };

  const ClassNameReturnPurchase2 = () => {
    let className = " col-md-12 col-lg-4";
    if (
      // store.Role === process.env.REACT_APP_ROLE_PURCHASE ||
      store.Role === process.env.REACT_APP_ROLE_SALES_MANAGER ||
      store.Role === process.env.REACT_APP_ROLE_CLIENT_FEEDBACK ||
      store.Role === process.env.REACT_APP_ROLE_SALESCOORDINATOR
    ) {
      className = " col-md-12 col-lg-12";
    }
    return className;
  };

  const ClassNameSalesLeaderboard = () => {
    let className = "col-12 col-lg-8";
    if (
      store.Role === process.env.REACT_APP_ROLE_ADMIN ||
      store.Role === process.env.REACT_APP_ROLE_SALES_MANAGER ||
      store.Role === process.env.REACT_APP_ROLE_CLIENT_FEEDBACK ||
      store.Role === process.env.REACT_APP_ROLE_SALESCOORDINATOR
    ) {
      className = "col-12 col-lg-12";
    }
    return className;
  };

  const deleteEnquiry = (id) => {
    // setLoading(true);
    performRequest("DELETE", `/allTablesCount/moveEnquiry/${id}`)
      .then((res) => {
        if (res.status === 200) {
          Toast("success", "Enquiry deleted successfully");
          setTodaysData((prev) => ({
            ...prev,
            todaysEnquiry: prev?.todaysEnquiry.filter((item) => item.id !== id),
          }));
        } else if (res.status === 201) {
          Toast("success", "Enquiry added to marketing list!");
        } else {
          Toast("error", "Error while delete enquiry ");
        }
      })
      .catch((err) => {
        CustomErrorResponse("Error", err);
      })
      .finally(() => setLoading(false));
  };

  const goToAllTask = () => {
    navigate(`/task-management`);
  };

  const goToAllProjectTimeline = () => {
    navigate(`/client-project-tracking`);
  };

  const goToAllEmployeeLeaves = () => {
    navigate(`/employee-leave-management`);
  };

  const goToVehicleIn = () => {
    navigate(`/hydroponic-material-inventory`);
  };
  const goToVehicleOut = () => {
    navigate(`/delivery-challan?`);
  };
  const goToStockVerification = () => {
    navigate(`/hydroponic-material-inventory`);
  };
  const goToReqPayment = () => {
    navigate(`/req-for-payment`);
  };

  const handelSubmit = async (id, item, values, { resetForm }) => {
    try {
      const previousCost = parseFloat(item?.cost) || 0;
      const previousInStock = parseFloat(item?.inStock) || 0;
      const newCost = parseFloat(values?.cost) || 0;
      const newInStock = parseFloat(values?.inStock) || 0;
      if (!newCost || !newInStock) {
        Toast("error", "please add cost and stock items!");
        return;
      }
      const updatedCost =
        (previousInStock * previousCost + newInStock * newCost) /
        (previousInStock + newInStock);

      const updatedStock = previousInStock + newInStock;
      let stockUpdateHistory = [];
      if (item.stockUpdateHistory) {
        stockUpdateHistory = item.stockUpdateHistory;
      }

      stockUpdateHistory.push({
        cost: newCost,
        inStock: newInStock,
        costFromVendor: values.costFromVendor,
        date: new Date(),
        invoiceNumber: values.invoiceNumber,
        generatedBy: store.Name,
      });
      const updateData = {
        inStock: updatedStock,
        cost: parseFloat(updatedCost),
        stockUpdateHistory,
      };
      await performRequest(
        "PATCH",
        `/materialPlanning/updateMaterialList/${id}`,
        updateData
      );

      Toast("success", "Inventory updated successfully!");

      setCost((prev) => {
        if (!Array.isArray(prev)) return prev;
        const updated = [...prev];
        updated[id] = Number(updatedCost.toFixed(2));
        return updated;
      });

      resetForm();
      setRefresh((prev) => !prev);
    } catch (err) {
      CustomErrorResponse(err);
    }
  };

  const ClassNameReturnHrLeaves = () => {
    let className = "col-12 col-lg-4";
    if (
      store.Role === process.env.REACT_APP_ROLE_HR ||
      store.Role === process.env.REACT_APP_ROLE_JR_HR
    ) {
      className = "col-12";
    }
    return className;
  };

  return (
    <>
      {(store?.Role === process.env.REACT_APP_ROLE_CLIENT ||
        store?.Role === process.env.REACT_APP_ROLE_D_CLIENT ||
        store?.Role === process.env.REACT_APP_ROLE_SITE_INSPECTION) && (
        <Suspense fallback={<LoadingPage />}>
          <FarmConstructionAgreement />
        </Suspense>
      )}

      {store?.Role !== process.env.REACT_APP_ROLE_CLIENT &&
        store?.Role !== process.env.REACT_APP_ROLE_D_CLIENT &&
        store?.Role !== process.env.REACT_APP_ROLE_SITE_INSPECTION && (
          <div className="page">
            <div className="page-wrapper">
              <div style={{ minHeight: "80vh" }}>
                <div className="page-body m-0">
                  <div className="container-xxl">
                    <button
                      id="pk"
                      data-bs-target="#modal-simple"
                      className="d-none"
                    ></button>
                    <div className="row row-deck row-cards m-0">
                      {(store?.Role === process.env.REACT_APP_ROLE_SALLE ||
                        store?.Role ===
                          process.env.REACT_APP_ROLE_SALLE_ADMIN ||
                        store?.Role ===
                          process.env.REACT_APP_ROLE_SALES_MANAGER ||
                        store?.Role ===
                          process.env.REACT_APP_ROLE_CLIENT_FEEDBACK) && (
                        <div className="col-md-12 col-lg-6">
                          <div
                            className="card"
                            style={{
                              backgroundColor: "rgb(231, 84, 128, 0.15)",
                            }}
                          >
                            {/* <div className="card-status-top bg-blue"></div> */}
                            <div className="card-header">
                              <h3 className="card-title">Todays followups</h3>
                            </div>

                            <div
                              className="card-table table-responsive"
                              style={{ maxHeight: "470px" }}
                            >
                              <table className="table table-vcenter">
                                <thead>
                                  <tr>
                                    <th
                                      style={{
                                        backgroundColor: "rgb(231, 84, 128, 0)",
                                      }}
                                    >
                                      Full Name
                                    </th>
                                    <th
                                      style={{
                                        backgroundColor: "rgb(231, 84, 128, 0)",
                                      }}
                                    >
                                      Lead Owner
                                    </th>
                                    <th
                                      style={{
                                        backgroundColor: "rgb(231, 84, 128, 0)",
                                      }}
                                    >
                                      Actions
                                    </th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {todaysData?.pendingFollowupTodayData?.map(
                                    (followup) => (
                                      <tr key={followup.id}>
                                        <td>{followup?.full_name}</td>
                                        {/* <td>{followup?.lead_alloted_to}</td> */}
                                        <td>{followup?.reAssignTo}</td>
                                        <td>
                                          <CustomViewButton
                                            onClick={() =>
                                              goToViewPendingFollwup(
                                                followup?.id
                                              )
                                            }
                                          ></CustomViewButton>
                                        </td>
                                      </tr>
                                    )
                                  )}
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                      )}
                      {(store?.Role === process.env.REACT_APP_ROLE_SALLE ||
                        store?.Role ===
                          process.env.REACT_APP_ROLE_SALLE_ADMIN ||
                        store?.Role ===
                          process.env.REACT_APP_ROLE_SALES_MANAGER) && (
                        <div className="col-md-12 col-lg-6">
                          <div
                            className="card"
                            style={{
                              backgroundColor: "rgb(129, 219, 189, 0.15)",
                            }}
                          >
                            {/* <div className="card-status-top bg-green"></div> */}
                            <div className="card-header d-flex justify-content-between">
                              <h3 className="card-title">New enquiries</h3>
                              <button
                                disabled={
                                  todaysData?.todaysEnquiry?.length > 20
                                }
                                onClick={assignNewEnquires}
                                className="btn btn-primary mx-1"
                              >
                                Get new enquiries
                              </button>
                            </div>

                            <div
                              className="card-table table-responsive"
                              style={{ maxHeight: "470px" }}
                            >
                              <table className="table table-vcenter">
                                <thead>
                                  <tr>
                                    <th
                                      style={{
                                        backgroundColor:
                                          "rgb(129, 219, 189, 0)",
                                      }}
                                    >
                                      Sr.No
                                    </th>
                                    <th
                                      style={{
                                        backgroundColor:
                                          "rgb(129, 219, 189, 0)",
                                      }}
                                    >
                                      Full Name
                                    </th>
                                    <th
                                      style={{
                                        backgroundColor:
                                          "rgb(129, 219, 189, 0)",
                                      }}
                                    >
                                      Contact Number
                                    </th>
                                    <th
                                      style={{
                                        backgroundColor:
                                          "rgb(129, 219, 189, 0)",
                                      }}
                                    >
                                      massege/ interest
                                    </th>
                                    <th
                                      style={{
                                        backgroundColor:
                                          "rgb(129, 219, 189, 0)",
                                      }}
                                    >
                                      Actions
                                    </th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {todaysData?.todaysEnquiry?.map(
                                    (enquiry, index) => (
                                      <tr
                                        key={enquiry.id}
                                        className={
                                          enquiry.transferBy
                                            ? "bg-purple-lt"
                                            : ""
                                        }
                                      >
                                        <td
                                          key={enquiry.id}
                                          className={
                                            enquiry.transferBy
                                              ? "text-black"
                                              : ""
                                          }
                                        >
                                          {index + 1}
                                        </td>
                                        <td
                                          className={
                                            enquiry.transferBy
                                              ? "text-black"
                                              : ""
                                          }
                                        >
                                          {enquiry?.fullName ||
                                            enquiry?.firstName ||
                                            enquiry?.lastName ||
                                            enquiry?.email ||
                                            "N/A"}
                                        </td>
                                        <td
                                          className={
                                            enquiry.transferBy
                                              ? "text-black"
                                              : ""
                                          }
                                        >
                                          {enquiry?.mobileNumber ||
                                            "Not Available"}
                                        </td>
                                        <td
                                          className={
                                            enquiry.transferBy
                                              ? "text-black"
                                              : ""
                                          }
                                        >
                                          {enquiry?.customerMessage ||
                                            enquiry?.interestedProduct ||
                                            "N/A"}
                                        </td>
                                        <td colSpan="2">
                                          {enquiry?.mobileNumber ? (
                                            <button
                                              className="btn btn-primarybtn btn-sm px-3 btn-primary"
                                              data-bs-toggle="modal"
                                              data-bs-target="#modal-report"
                                              onClick={() =>
                                                setModalData(enquiry)
                                              }
                                            >
                                              Assign To Me
                                            </button>
                                          ) : (
                                            <button
                                              className="btn btn-danger btn-sm px-3"
                                              onClick={() =>
                                                deleteEnquiry(enquiry?.id)
                                              }
                                            >
                                              Delete
                                            </button>
                                          )}
                                        </td>
                                      </tr>
                                    )
                                  )}
                                </tbody>
                              </table>
                              <div
                                className="modal modal-blur fade"
                                id="modal-report"
                                tabIndex="-1"
                                role="dialog"
                                aria-hidden="true"
                              >
                                <div
                                  className="modal-dialog modal-lg modal-dialog-centered"
                                  role="document"
                                >
                                  <div className="modal-content">
                                    <div className="modal-header">
                                      <h5 className="modal-title">
                                        Filter lead
                                      </h5>
                                      <button
                                        type="button"
                                        className="btn-close"
                                        data-bs-dismiss="modal"
                                        aria-label="Close"
                                      ></button>
                                    </div>
                                    <div className="modal-body">
                                      {modalData && (
                                        <>
                                          <div className="mb-3 row">
                                            <label className="w-25 form-label col-3">
                                              Full name
                                            </label>
                                            <div className="w-100 col">
                                              {(
                                                modalData?.fullName ||
                                                modalData?.firstName ||
                                                "N/A"
                                              ).toUpperCase()}
                                            </div>
                                          </div>
                                          <div className="mb-3 row">
                                            <label className="w-25 form-label col-3">
                                              Address
                                            </label>
                                            <div className="w-100 col">
                                              {(
                                                modalData.address1 ||
                                                modalData.address2 ||
                                                "N/A"
                                              ).toUpperCase()}
                                            </div>
                                          </div>

                                          <div className="mb-3 row">
                                            <label className="w-25 form-label col-3">
                                              Email Address
                                            </label>
                                            <div className="w-100 col">
                                              {modalData?.email || "N/A"}
                                            </div>
                                          </div>
                                          <div className="mb-3 row">
                                            <label className="w-25 form-label col-3">
                                              Phone Number
                                            </label>
                                            <div className="w-100 col">
                                              {modalData?.mobileNumber ||
                                              modalData?.whatsappNumber ? (
                                                <span
                                                  onClick={() =>
                                                    handleCall(
                                                      modalData?.mobileNumber ||
                                                        modalData?.whatsappNumber
                                                    )
                                                  }
                                                  className="cursor-pointer text-blue text-decoration-underline"
                                                >
                                                  <svg
                                                    color="green"
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    width="24"
                                                    height="24"
                                                    viewBox="0 0 24 24"
                                                    fill="none"
                                                    stroke="currentColor"
                                                    strokeWidth="2"
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                    className="icon icon-tabler icons-tabler-outline icon-tabler-phone-outgoing"
                                                  >
                                                    <path
                                                      stroke="none"
                                                      d="M0 0h24v24H0z"
                                                      fill="none"
                                                    />
                                                    <path d="M5 4h4l2 5l-2.5 1.5a11 11 0 0 0 5 5l1.5 -2.5l5 2v4a2 2 0 0 1 -2 2a16 16 0 0 1 -15 -15a2 2 0 0 1 2 -2" />
                                                    <path d="M15 9l5 -5" />
                                                    <path d="M16 4l4 0l0 4" />
                                                  </svg>

                                                  {modalData?.mobileNumber ||
                                                    modalData?.whatsappNumber}
                                                </span>
                                              ) : (
                                                ""
                                              )}
                                            </div>
                                          </div>
                                          {/* <div className="mb-3 row d-lg-none d-md-none">
                    <label className="w-25 form-label col-3">Call Now</label>
                    <div className="w-100 col">
                      <SimpleButton buttonText="Call Now" />
                    </div>
                  </div> */}
                                          <div className="mb-3 row">
                                            <label className="w-25 form-label col-3">
                                              Lead Generated From
                                            </label>
                                            <div className="w-100 col">
                                              {(
                                                modalData?.origin || "N/A"
                                              ).toUpperCase()}
                                            </div>
                                          </div>

                                          <div className="mb-3 row">
                                            <label className="w-25 form-label col-3">
                                              Lead Transfer By
                                            </label>
                                            <div className="w-100 col">
                                              {(
                                                modalData?.transferBy || "N/A"
                                              ).toUpperCase()}
                                            </div>
                                          </div>
                                        </>
                                      )}
                                    </div>

                                    <div className="modal-footer">
                                      <div>
                                        <SimpleButton
                                          buttonText="Not Connected"
                                          type="secondary"
                                          data-bs-dismiss="modal"
                                        />
                                      </div>

                                      <div className="ms-auto">
                                        <SimpleButton
                                          onClick={() =>
                                            AddAndAssignLead(modalData)
                                          }
                                          buttonText="Call Connected"
                                          data-bs-dismiss="modal"
                                        />
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                      {store?.Role ===
                        process.env.REACT_APP_ROLE_CLIENT_FEEDBACK && (
                        <div className="col-lg-6">
                          <div className="card card-sm">
                            <div className="card-header d-flex justify-content-between">
                              <h3 className="card-title">New Feedback</h3>
                              <button
                                style={{
                                  width: "110px",
                                  height: "30px",
                                }}
                                className="btn btn-primary"
                              >
                                Add Feedback
                              </button>
                            </div>

                            <div
                              className="card-table table-responsive"
                              style={{ maxHeight: "470px" }}
                            >
                              <table className="table table-vcenter">
                                <thead>
                                  <tr>
                                    <th>Client Name</th>
                                    <th>Contact Number</th>
                                    <th>Lead Owner</th>
                                    <th>Actions</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {clientFeedback?.assignedFeedback
                                    ?.filter(
                                      (enquiry) =>
                                        enquiry?.feedBackStatus === "pending"
                                    )
                                    .map((enquiry) => (
                                      <tr key={enquiry.id}>
                                        <td>{enquiry?.clientName || "N/A"}</td>
                                        <td>
                                          {enquiry?.clientContactNumber ||
                                            "N/A"}
                                        </td>
                                        <td>{enquiry?.leadOwner || "N/A"}</td>
                                        <td>
                                          <button
                                            style={{
                                              width: "110px",
                                              height: "30px",
                                            }}
                                            className="btn btn-primary"
                                            onClick={() =>
                                              goToView(enquiry?.feedbackId)
                                            }
                                          >
                                            Take Feedback
                                          </button>
                                        </td>
                                      </tr>
                                    ))}
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                      )}
                      {store.Role !== process.env.REACT_APP_ROLE_AGRONOMIST &&
                        store.Role !== process.env.REACT_APP_ROLE_SALESAGENCY &&
                        store.Role !== process.env.REACT_APP_ROLE_SALLE_ADMIN &&
                        store.Role !== process.env.REACT_APP_ROLE_PURCHASE &&
                        store?.Role !== process.env.REACT_APP_ROLE_SALLE &&
                        store?.Role !==
                          process.env.REACT_APP_ROLE_OFFICE_STAFF &&
                        store?.Role !==
                          process.env.REACT_APP_ROLE_MARKETING_AGENCY && (
                          <>
                            <div className={ClassNameReturnPurchase()}>
                              <div className="card bg-primary-lt card-sm">
                                <div className="card-body">
                                  <div className="row align-items-center">
                                    <div className="col-3">
                                      <span className="">
                                        <FcRatings className="fs-large" />
                                      </span>
                                    </div>
                                    <div className="col">
                                      <div className="fw-bold">
                                        {(tableData && tableData?.quotations) ||
                                          0}{" "}
                                        Quotation
                                      </div>
                                      <div className="text-muted">
                                        {(tableData &&
                                          tableData?.quotationsToday) ||
                                          0}{" "}
                                        today
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            {store.Role !==
                              process.env.REACT_APP_ROLE_PURCHASE && (
                              <div className="col-sm-6 col-lg-2">
                                <div className="card bg-primary-lt card-sm">
                                  <div className="card-body">
                                    <div className="row align-items-center">
                                      <div className="col-3">
                                        <span className="">
                                          {/* <IoCallOutline /> */}

                                          <FcCustomerSupport className="fs-large" />
                                        </span>
                                      </div>
                                      <div className="col">
                                        <div className="fw-bold">
                                          {" "}
                                          {(tableData &&
                                            tableData?.enquiryList) ||
                                            0}{" "}
                                          Enquiry
                                        </div>
                                        <div className="text-muted">
                                          {" "}
                                          {(tableData &&
                                            tableData?.enquiryListToday) ||
                                            0}{" "}
                                          today
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            )}
                            {store.Role !==
                              process.env.REACT_APP_ROLE_PURCHASE && (
                              <div className="col-sm-6 col-lg-2">
                                <div className="card bg-primary-lt card-sm">
                                  <div className="card-body">
                                    <div className="row align-items-center">
                                      <div className="col-3">
                                        <span className="">
                                          {/* <MdOutlineGroup /> */}
                                          <FcCallback className="fs-large" />
                                        </span>
                                      </div>
                                      <div className="col">
                                        <div className="fw-bold">
                                          {" "}
                                          {(tableData && tableData?.leads) ||
                                            0}{" "}
                                          Leads
                                        </div>
                                        <div className="text-muted">
                                          {" "}
                                          {(tableData &&
                                            tableData?.leadsToday) ||
                                            0}{" "}
                                          today
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            )}

                            {store.Role ===
                              process.env.REACT_APP_ROLE_SALLE && (
                              <h1>hello</h1>
                            )}

                            <div className={ClassNameReturnPurchase()}>
                              <div className="card bg-primary-lt card-sm">
                                <div className="card-body">
                                  <div className="row align-items-center">
                                    <div className="col-3">
                                      <span className="">
                                        {/* <TbReportSearch /> */}

                                        <FcLandscape className="fs-large" />
                                      </span>
                                    </div>
                                    <div className="col">
                                      <div className="fw-bold">
                                        {(tableData &&
                                          tableData?.siteInspections &&
                                          tableData?.clientProjects &&
                                          tableData.clientProjects +
                                            tableData.siteInspections) ||
                                          0}{" "}
                                        Site Insp.
                                      </div>
                                      <div className="text-muted">
                                        {(tableData &&
                                          tableData?.siteInspectionsToday) ||
                                          0}{" "}
                                        today
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className={ClassNameReturnPurchase()}>
                              <div className="card bg-primary-lt card-sm">
                                <div className="card-body">
                                  <div className="row align-items-center">
                                    <div className="col-3">
                                      <span className="">
                                        {/* <FaTasks /> */}
                                        <FcWorkflow className="fs-large" />
                                      </span>
                                    </div>
                                    <div className="col">
                                      <div className="fw-bold">
                                        {(tableData &&
                                          tableData?.clientProjects) ||
                                          0}{" "}
                                        Cl Project
                                      </div>
                                      <div className="text-muted">
                                        {" "}
                                        {(tableData &&
                                          tableData?.clientProjectsToday) ||
                                          0}{" "}
                                        today
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className={ClassNameReturnPurchase()}>
                              <div className="card bg-primary-lt card-sm">
                                <div className="card-body">
                                  <div className="row align-items-center">
                                    <div className="col-3">
                                      <span className="">
                                        <FcSignature className="fs-large" />
                                      </span>
                                    </div>
                                    <div className="col">
                                      <div className="fw-bold">
                                        {(tableData && tableData?.handOvers) ||
                                          0}{" "}
                                        Handovers
                                      </div>
                                      <div className="text-muted">
                                        {" "}
                                        {(tableData &&
                                          tableData?.handOversToday) ||
                                          0}{" "}
                                        today
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </>
                        )}
                      {store.Role == process.env.REACT_APP_ROLE_PURCHASE && (
                        <>
                          <div className={ClassNameReturnPurchase()}>
                            <div
                              className="card bg-primary-lt card-sm"
                              onClick={goToVehicleIn}
                            >
                              <div className="card-body">
                                <div className="row align-items-center">
                                  <div className="col-3">
                                    <span className="">
                                      <MdLogin size={40} color="#4caf50" />
                                    </span>
                                  </div>
                                  <div className="col">
                                    <div className="fw-bold">Vehicle In</div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className={ClassNameReturnPurchase()}>
                            <div
                              className="card bg-primary-lt card-sm"
                              onClick={goToVehicleOut}
                            >
                              <div className="card-body">
                                <div className="row align-items-center">
                                  <div className="col-3">
                                    <span className="">
                                      {/* <TbReportSearch /> */}

                                      <MdLogout size={40} color="#f44336" />
                                    </span>
                                  </div>
                                  <div className="col">
                                    <div className="fw-bold">Vehicle Out</div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className={ClassNameReturnPurchase()}>
                            <div
                              className="card bg-primary-lt card-sm"
                              onClick={goToStockVerification}
                            >
                              <div className="card-body">
                                <div className="row align-items-center">
                                  <div className="col-3">
                                    <span className="">
                                      {/* <FaTasks /> */}
                                      <MdChecklist size={40} color="#ff9800" />
                                    </span>
                                  </div>
                                  <div className="col">
                                    <div className="fw-bold">
                                      Stock Verification
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className={ClassNameReturnPurchase()}>
                            <div
                              className="card bg-primary-lt card-sm"
                              onClick={goToReqPayment}
                            >
                              <div className="card-body">
                                <div className="row align-items-center">
                                  <div className="col-3">
                                    <span className="">
                                      <MdPayment size={40} color="#2196f3" />
                                    </span>
                                  </div>
                                  <div className="col">
                                    <div className="fw-bold">Req. Payment</div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </>
                      )}
                      {(store.Role === process.env.REACT_APP_ROLE_SALLE ||
                        store.Role === process.env.REACT_APP_ROLE_SALLE_ADMIN ||
                        store.Role === process.env.REACT_APP_ROLE_OPS ||
                        store.Role === process.env.REACT_APP_ROLE_SALESAGENCY ||
                        store.Role === process.env.REACT_APP_ROLE_MARKETING ||
                        store.Role === process.env.REACT_APP_ROLE_ADMIN_S ||
                        store.Role ===
                          process.env.REACT_APP_ROLE_SALES_MANAGER ||
                        store.Role === process.env.REACT_APP_ROLE_ADMIN) &&
                        store.Role !== process.env.REACT_APP_ROLE_AGRONOMIST &&
                        store.Role !== process.env.REACT_APP_ROLE_MARKETING &&
                        store.Role !==
                          process.env.REACT_APP_ROLE_INSPECTION && (
                          <>
                            {leadOwner && store && (
                              <Suspense follback={<LoadingPage />}>
                                <EmployeeWorkData
                                  leadOwner={leadOwner}
                                  userData={store}
                                />
                              </Suspense>
                            )}
                          </>
                        )}
                      {store?.Role == process.env.REACT_APP_ROLE_PURCHASE && (
                        <div className="col-lg-8 col-md-12 row-deck">
                          <div
                            className="card card-sm"
                            style={{
                              backgroundColor: "rgb(210, 214, 220, 0.20)",
                            }}
                          >
                            {/* <div className="card-header"> */}
                            <div className="card-header d-flex justify-content-between align-items-center">
                              <h3 className="card-title">Inventory</h3>
                              <div className="d-flex align-items-center gap-2">
                                <h4 className="status mb-0">
                                  <span style={{ color: "red" }}>
                                    {inventoryThresholdData}
                                  </span>
                                  /
                                  <span style={{ color: "green" }}>
                                    {inventoryCountData}
                                  </span>
                                </h4>
                                {/* <CustomViewButton
                                  onClick={() => goToAllInventory()}
                                  label="All Inventory"
                                /> */}
                              </div>
                            </div>
                            <div
                              className="card-table table-responsive"
                              style={{ maxHeight: "285px" }}
                            >
                              <table className="table table-vcenter">
                                <thead>
                                  <tr>
                                    <th
                                      style={{
                                        backgroundColor:
                                          "rgb(255, 244, 184, 0)",
                                      }}
                                    >
                                      Item Name
                                    </th>
                                    <th
                                      style={{
                                        backgroundColor:
                                          "rgb(255, 244, 184, 0)",
                                      }}
                                    >
                                      Instock
                                    </th>
                                    <th
                                      style={{
                                        backgroundColor:
                                          "rgb(255, 244, 184, 0)",
                                      }}
                                    >
                                      Threashold Limit
                                    </th>
                                    <th
                                      style={{
                                        backgroundColor:
                                          "rgb(255, 244, 184, 0)",
                                      }}
                                    >
                                      Actions
                                    </th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {inventoryData?.map((inventory) => (
                                    <tr key={inventory?.id}>
                                      <td>{inventory?.item}</td>
                                      <td>{inventory?.inStock}</td>
                                      <td>{inventory?.thresholdLimit}</td>

                                      <td>
                                        <button
                                          className="btn btn-sm px-3 mt-1 btn-primary"
                                          data-bs-toggle="modal"
                                          data-bs-target={`#modal-team-${inventory?.id}`}
                                          style={{
                                            width: "80px",
                                            height: "25px",
                                          }}
                                        >
                                          Add Item
                                        </button>
                                        <div
                                          className="modal modal-blur fade"
                                          id={`modal-team-${inventory?.id}`}
                                          tabIndex="-1"
                                          role="dialog"
                                          aria-hidden="true"
                                        >
                                          <Formik
                                            initialValues={
                                              HydroponicMaterialInfo
                                            }
                                            validationSchema={
                                              AddItemHydroponicMaterial
                                            }
                                            onSubmit={(values, actions) =>
                                              handelSubmit(
                                                inventory?.id,
                                                inventory,
                                                values,
                                                actions
                                              )
                                            }
                                            enableReinitialize
                                          >
                                            {(props) => (
                                              <Form className="modal-dialog modal-dialog-centered w-lg-100 w-md-100">
                                                <div className="modal-dialog modal-dialog-centered w-100">
                                                  <div className="modal-content">
                                                    <div className="modal-header">
                                                      <h5 className="modal-title">
                                                        Add Items
                                                      </h5>
                                                      <button
                                                        type="button"
                                                        className="btn-close"
                                                        data-bs-dismiss="modal"
                                                        aria-label="Close"
                                                      ></button>
                                                    </div>
                                                    <div className="modal-body">
                                                      <div className="mb-3">
                                                        <label className="form-label required">
                                                          Add item in stock
                                                        </label>
                                                        <CustomInput
                                                          name="inStock"
                                                          type="text"
                                                        />
                                                        {props.touched
                                                          .inStock &&
                                                          props.errors
                                                            .inStock && (
                                                            <p className="text-danger">
                                                              {
                                                                props.errors
                                                                  .inStock
                                                              }
                                                            </p>
                                                          )}
                                                      </div>
                                                      <div className="mb-3">
                                                        <label className="form-label required">
                                                          Cost per unit
                                                        </label>
                                                        <CustomInput
                                                          name="cost"
                                                          type="text"
                                                        />
                                                        {props.touched.cost &&
                                                          props.errors.cost && (
                                                            <p className="text-danger">
                                                              {
                                                                props.errors
                                                                  .cost
                                                              }
                                                            </p>
                                                          )}
                                                      </div>
                                                      <div className="mb-3">
                                                        <label className="form-label">
                                                          Cost from vendor
                                                        </label>
                                                        <CustomSelect
                                                          type="text"
                                                          name="costFromVendor"
                                                        >
                                                          <option value="">
                                                            Select
                                                          </option>
                                                          {vendorList?.map(
                                                            (item) => {
                                                              return (
                                                                <option
                                                                  key={item.id}
                                                                  value={
                                                                    item.businessName
                                                                  }
                                                                >
                                                                  {
                                                                    item.businessName
                                                                  }
                                                                </option>
                                                              );
                                                            }
                                                          )}
                                                        </CustomSelect>
                                                        {props.touched
                                                          .costFromVendor &&
                                                          props.errors
                                                            .costFromVendor && (
                                                            <p className="text-danger">
                                                              {
                                                                props.errors
                                                                  .costFromVendor
                                                              }
                                                            </p>
                                                          )}
                                                      </div>
                                                      <div className="mb-3">
                                                        <label className="form-label required">
                                                          Invoice Num / PI Num
                                                        </label>
                                                        <CustomInput
                                                          name="invoiceNumber"
                                                          type="text"
                                                        />
                                                        {props.touched
                                                          .invoiceNumber &&
                                                          props.errors
                                                            .invoiceNumber && (
                                                            <p className="text-danger">
                                                              {
                                                                props.errors
                                                                  .invoiceNumber
                                                              }
                                                            </p>
                                                          )}
                                                      </div>
                                                    </div>
                                                    <div className="modal-footer">
                                                      <button
                                                        type="button"
                                                        className="btn btn-secondary"
                                                        data-bs-dismiss="modal"
                                                      >
                                                        Close
                                                      </button>
                                                      <FormSubmitButton
                                                        isSubmitting={
                                                          props.isSubmitting
                                                        }
                                                        buttonText="Submit"
                                                        data-bs-dismiss="modal"
                                                      />
                                                    </div>
                                                  </div>
                                                </div>
                                              </Form>
                                            )}
                                          </Formik>
                                        </div>
                                      </td>
                                    </tr>
                                  ))}
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                      )}
                      {store?.Role !== process.env.REACT_APP_ROLE_ACCOUNTS &&
                        store?.Role !== process.env.REACT_APP_ROLE_PURCHASE &&
                        store?.Role !==
                          process.env.REACT_APP_ROLE_OFFICE_STAFF &&
                        store?.Role !==
                          process.env.REACT_APP_ROLE_MARKETING_AGENCY && (
                          <div className="col-lg-8 col-md-12 row-deck">
                            <div
                              className="card card-sm"
                              style={{
                                backgroundColor: "rgb(255, 244, 184, 0.2)",
                              }}
                            >
                              {/* <div className="card-header"> */}
                              <div className="card-header d-flex justify-content-between align-items-center">
                                <h3 className="card-title">Today's Tasks</h3>
                                <CustomViewButton
                                  onClick={() => goToAllTask()}
                                  label="All Tasks"
                                ></CustomViewButton>
                              </div>
                              <div
                                className="card-table table-responsive"
                                style={{ maxHeight: "470px" }}
                              >
                                <table className="table table-vcenter">
                                  <thead>
                                    <tr>
                                      <th
                                        style={{
                                          backgroundColor:
                                            "rgb(255, 244, 184, 0)",
                                        }}
                                      >
                                        Name
                                      </th>
                                      <th
                                        style={{
                                          backgroundColor:
                                            "rgb(255, 244, 184, 0)",
                                        }}
                                      >
                                        Priority
                                      </th>
                                      <th
                                        style={{
                                          backgroundColor:
                                            "rgb(255, 244, 184, 0)",
                                        }}
                                      >
                                        Status
                                      </th>
                                      <th
                                        style={{
                                          backgroundColor:
                                            "rgb(255, 244, 184, 0)",
                                        }}
                                      >
                                        Deadline
                                      </th>
                                      <th
                                        style={{
                                          backgroundColor:
                                            "rgb(255, 244, 184, 0)",
                                        }}
                                      >
                                        Task Type
                                      </th>
                                      <th
                                        style={{
                                          backgroundColor:
                                            "rgb(255, 244, 184, 0)",
                                        }}
                                      >
                                        Actions
                                      </th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {sortedData?.map((task) => (
                                      <tr key={task.id}>
                                        <td>{task?.name}</td>
                                        <td>
                                          {task?.priority === "P1" ? (
                                            <span
                                              className="badge text-white text-center bg-red "
                                              style={{ padding: "4px" }}
                                            >
                                              {task?.priority}
                                            </span>
                                          ) : task?.priority === "P2" ? (
                                            <span
                                              className="badge text-white bg-yellow"
                                              style={{ padding: "4px" }}
                                            >
                                              {task?.priority}
                                            </span>
                                          ) : task?.priority === "P3" ? (
                                            <span
                                              className="badge text-white bg-green"
                                              style={{ padding: "4px" }}
                                            >
                                              {task?.priority}
                                            </span>
                                          ) : null}
                                        </td>
                                        <td>
                                          {task?.status === "pending" ? (
                                            <span
                                              className="badge bg-orange"
                                              style={{ color: "white" }}
                                            >
                                              Pending
                                            </span>
                                          ) : (
                                            <span
                                              className="badge bg-green"
                                              style={{ color: "white" }}
                                            >
                                              Completed
                                            </span>
                                          )}
                                        </td>
                                        <td>
                                          {task?.deadline ||
                                            new Date()
                                              .toISOString()
                                              .split("T")[0]}
                                        </td>
                                        <td>{task?.taskType || "N/A"}</td>
                                        <td>
                                          {/* <button
                                          className="btn btn-primary"
                                          style={{
                                            width: "50px",
                                            height: "25px",
                                          }}
                                          onClick={() => goToViewTaks(task?.id)}
                                        >
                                          View
                                        </button> */}
                                          <CustomViewButton
                                            onClick={() =>
                                              goToViewTaks(task?.id)
                                            }
                                          ></CustomViewButton>
                                        </td>
                                      </tr>
                                    ))}
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          </div>
                        )}
                      {store?.Role ===
                        process.env.REACT_APP_ROLE_MARKETING_AGENCY && (
                        <div>
                          <h1 style={{ textAlign: "center" }}>ASSIGNED TASK</h1>
                          <hr></hr>
                          <div className="col-md-12 py-2">
                            <div className="card">
                              {marketingTask && (
                                <MediaTaskTable
                                  data={marketingTask}
                                  currentPage={page}
                                  itemsPerPage={50}
                                />
                              )}

                              <Pagination
                                page={page}
                                setPage={setPage}
                                totalPages={totalPages}
                                pageDatalength={marketingTask?.length}
                                showPage={showPage}
                                setShowPage={setShowPage}
                              />
                            </div>
                          </div>
                        </div>
                      )}
                      {store?.Role !== process.env.REACT_APP_ROLE_ACCOUNTS &&
                        store?.Role !==
                          process.env.REACT_APP_ROLE_OFFICE_STAFF &&
                        store?.Role !==
                          process.env.REACT_APP_ROLE_MARKETING_AGENCY &&
                        taskScore.attendancePercentage &&
                        taskScore.taskCompletionPercentage && (
                          <div className="col-lg-4 row-deck">
                            <div
                              className="card p-2"
                              style={{
                                backgroundColor: "rgb(255, 215, 0, 0.18)",
                              }}
                            >
                              <div className="card-header p-2 d-flex justify-content-between position-relative">
                                <h3 className="card-title">EEP Score</h3>
                                <h3 className="card-title">
                                  Today's Points:{" "}
                                  <img
                                    src="https://res.cloudinary.com/dezupfsqo/image/upload/v1737435786/dayStreakFireIcon_jtmz2c.png"
                                    alt="points"
                                    className="me-1 ms-1 mb-1"
                                    width={20}
                                  />
                                  {points}
                                </h3>

                                <div className="position-relative d-inline-block">
                                  <div
                                    onMouseEnter={() => setShowInfo(true)}
                                    onMouseLeave={() => setShowInfo(false)}
                                    style={{ cursor: "pointer" }}
                                  >
                                    <IoInformationCircleOutline
                                      className={`fs-2 me-2 ${
                                        showInfo ? "text-primary" : ""
                                      }`}
                                    />
                                    {showInfo && (
                                      <div
                                        className="info-box p-3 shadow-lg rounded bg-white position-absolute"
                                        style={{
                                          top: "35px",
                                          left: "50%",
                                          transform: "translateX(-50%)",
                                          width: "280px",
                                          border: "1px solid #ddd",
                                          zIndex: 1000,
                                        }}
                                      >
                                        <ul className="mb-0">
                                          <li>
                                            1 task completed: Earn 1 point
                                          </li>
                                          <li>
                                            Login on time and completed 9 hours:
                                            Earn 5 points
                                          </li>
                                          <li>
                                            Login late but still completed 9
                                            hours: Earn 4 points
                                          </li>
                                          <li>
                                            Leave without approval: Earn 0
                                            points
                                          </li>
                                          <li>
                                            Paid leave with approval: Earn 5
                                            points
                                          </li>
                                          <li>
                                            Unpaid leave with approval: Earn 4
                                            points
                                          </li>
                                          <li>
                                            Unconfirmed leave (half day): Deduct
                                            1 point
                                          </li>
                                          <li>
                                            Unconfirmed leave (full day): Deduct
                                            5 points
                                          </li>
                                        </ul>
                                      </div>
                                    )}
                                  </div>
                                </div>
                              </div>
                              <div className="card-body p-0">
                                <div className="d-flex align-items-center">
                                  <div className="subheader fs-5 mt-1">
                                    Task score above 90% is required
                                  </div>
                                </div>
                                <div className="h3 mb-2 mt-2">
                                  Your task score:{" "}
                                  {Math.min(
                                    taskScore?.taskCompletionPercentage,
                                    100
                                  )}
                                  %
                                </div>

                                <div className="d-flex mb-2">
                                  <div>Task progress</div>
                                </div>

                                <div className="progress progress-sm">
                                  <div
                                    className={`progress-bar ${getProgressBarColor(
                                      taskScore?.taskCompletionPercentage
                                    )}`}
                                    style={{
                                      width: `${taskScore?.taskCompletionPercentage}%`,
                                    }}
                                    role="progressbar"
                                    aria-valuenow={
                                      taskScore?.taskCompletionPercentage
                                    }
                                    aria-valuemin="0"
                                    aria-valuemax="100"
                                    aria-label={`${taskScore?.taskCompletionPercentage}% Complete`}
                                  ></div>
                                </div>

                                <hr className="m-2" />

                                <div className="d-flex align-items-center">
                                  <div className="subheader fs-5">
                                    Attendance score above 90% is required
                                  </div>
                                </div>
                                <div className="h3 mb-2 mt-2">
                                  Your attendance score:{" "}
                                  {taskScore?.attendancePercentage}%
                                </div>

                                <div className="d-flex mb-2">
                                  <div>Attendance progress</div>
                                </div>

                                <div className="progress progress-sm">
                                  <div
                                    className={`progress-bar ${getProgressBarColor(
                                      taskScore?.attendancePercentage
                                    )}`}
                                    style={{
                                      width: `${taskScore?.attendancePercentage}%`,
                                    }}
                                    role="progressbar"
                                    aria-valuenow={
                                      taskScore?.attendancePercentage
                                    }
                                    aria-valuemin="0"
                                    aria-valuemax="100"
                                    aria-label={`${taskScore?.attendancePercentage}% Complete`}
                                  ></div>
                                </div>

                                <div className="mt-3">
                                  {taskScore?.taskCompletionPercentage >= 90 &&
                                  taskScore?.attendancePercentage >= 90 ? (
                                    <div
                                      className="alert alert-success fw-bold"
                                      role="alert"
                                    >
                                      🎉 Congratulations! You are eligible.
                                    </div>
                                  ) : (
                                    <div
                                      className="alert alert-danger fw-bold"
                                      role="alert"
                                    >
                                      ❌ You are not eligible. Improve your
                                      scores to qualify.
                                    </div>
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                        )}
                      {store?.Role == process.env.REACT_APP_ROLE_PURCHASE && (
                        <div className="col-lg-8 col-md-12 row-deck">
                          <div
                            className="card card-sm"
                            style={{
                              backgroundColor: "rgb(255, 244, 184, 0.2)",
                            }}
                          >
                            {/* <div className="card-header"> */}
                            <div className="card-header d-flex justify-content-between align-items-center">
                              <h3 className="card-title">Today's Tasks</h3>
                              <CustomViewButton
                                onClick={() => goToAllTask()}
                                label="All Tasks"
                              ></CustomViewButton>
                            </div>
                            <div
                              className="card-table table-responsive"
                              style={{ maxHeight: "470px" }}
                            >
                              <table className="table table-vcenter">
                                <thead>
                                  <tr>
                                    <th
                                      style={{
                                        backgroundColor:
                                          "rgb(255, 244, 184, 0)",
                                      }}
                                    >
                                      Name
                                    </th>
                                    <th
                                      style={{
                                        backgroundColor:
                                          "rgb(255, 244, 184, 0)",
                                      }}
                                    >
                                      Priority
                                    </th>
                                    <th
                                      style={{
                                        backgroundColor:
                                          "rgb(255, 244, 184, 0)",
                                      }}
                                    >
                                      Status
                                    </th>
                                    <th
                                      style={{
                                        backgroundColor:
                                          "rgb(255, 244, 184, 0)",
                                      }}
                                    >
                                      Deadline
                                    </th>
                                    <th
                                      style={{
                                        backgroundColor:
                                          "rgb(255, 244, 184, 0)",
                                      }}
                                    >
                                      Task Type
                                    </th>
                                    <th
                                      style={{
                                        backgroundColor:
                                          "rgb(255, 244, 184, 0)",
                                      }}
                                    >
                                      Actions
                                    </th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {sortedData?.map((task) => (
                                    <tr key={task.id}>
                                      <td>{task?.name}</td>
                                      <td>
                                        {task?.priority === "P1" ? (
                                          <span
                                            className="badge text-white text-center bg-red "
                                            style={{ padding: "4px" }}
                                          >
                                            {task?.priority}
                                          </span>
                                        ) : task?.priority === "P2" ? (
                                          <span
                                            className="badge text-white bg-yellow"
                                            style={{ padding: "4px" }}
                                          >
                                            {task?.priority}
                                          </span>
                                        ) : task?.priority === "P3" ? (
                                          <span
                                            className="badge text-white bg-green"
                                            style={{ padding: "4px" }}
                                          >
                                            {task?.priority}
                                          </span>
                                        ) : null}
                                      </td>
                                      <td>
                                        {task?.status === "pending" ? (
                                          <span
                                            className="badge bg-orange"
                                            style={{ color: "white" }}
                                          >
                                            Pending
                                          </span>
                                        ) : (
                                          <span
                                            className="badge bg-green"
                                            style={{ color: "white" }}
                                          >
                                            Completed
                                          </span>
                                        )}
                                      </td>
                                      <td>
                                        {task?.deadline ||
                                          new Date()
                                            .toISOString()
                                            .split("T")[0]}
                                      </td>
                                      <td>{task?.taskType || "N/A"}</td>
                                      <td>
                                        {/* <button
                                          className="btn btn-primary"
                                          style={{
                                            width: "50px",
                                            height: "25px",
                                          }}
                                          onClick={() => goToViewTaks(task?.id)}
                                        >
                                          View
                                        </button> */}
                                        <CustomViewButton
                                          onClick={() => goToViewTaks(task?.id)}
                                        ></CustomViewButton>
                                      </td>
                                    </tr>
                                  ))}
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                      )}
                      {store.Role !== process.env.REACT_APP_ROLE_SALESAGENCY &&
                        store.Role !== process.env.REACT_APP_ROLE_INSPECTION &&
                        store.Role !== process.env.REACT_APP_ROLE_SALLE &&
                        store.Role !== process.env.REACT_APP_ROLE_SALLE_ADMIN &&
                        store.Role !== process.env.REACT_APP_ROLE_IT &&
                        store.Role !== process.env.REACT_APP_ROLE_AGRONOMIST &&
                        store.Role !== process.env.REACT_APP_ROLE_HR &&
                        store.Role !== process.env.REACT_APP_ROLE_JR_HR &&
                        store.Role !== process.env.REACT_APP_ROLE_ACCOUNTS &&
                        store.Role !== process.env.REACT_APP_ROLE_SSM &&
                        store?.Role !==
                          process.env.REACT_APP_ROLE_SALESCOORDINATOR &&
                        store?.Role !== process.env.REACT_APP_ROLE_MARKETING &&
                        store?.Role !==
                          process.env.REACT_APP_ROLE_OFFICE_STAFF &&
                        store?.Role !==
                          process.env.REACT_APP_ROLE_MARKETING_AGENCY && (
                          <div className={ClassNameReturnPurchase2()}>
                            <div
                              className="card"
                              style={{
                                backgroundColor: "rgb(135, 207, 250, 0.15)",
                              }}
                            >
                              {/* <div className="card-header"> */}
                              <div className="card-header d-flex justify-content-between align-items-center">
                                <h3 className="card-title">Project Timeline</h3>
                                <CustomViewButton
                                  onClick={() => goToAllProjectTimeline()}
                                  label="All Project Timeline"
                                ></CustomViewButton>
                              </div>
                              <div
                                className="card-table table-responsive"
                                style={{ maxHeight: "400px" }}
                              >
                                <table className="table table-vcenter">
                                  <thead>
                                    <tr>
                                      <th
                                        style={{
                                          backgroundColor:
                                            "rgb(135, 207, 250, 0)",
                                        }}
                                      >
                                        Project
                                      </th>
                                      <th
                                        colSpan="2"
                                        style={{
                                          backgroundColor:
                                            "rgb(135, 207, 250, 0)",
                                        }}
                                      >
                                        Steps & Progress
                                      </th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {projectTrackingData?.map((item, index) => {
                                      return (
                                        <tr key={index}>
                                          <td className="w-66">
                                            {item?.projectClientName || "N/A"}
                                          </td>
                                          <td>
                                            {getTaskListDetails(item?.taskList)}
                                          </td>
                                          <td className="w-33">
                                            <div className="progress progress-xs">
                                              <div
                                                className="progress-bar bg-primary"
                                                style={{
                                                  width:
                                                    getTaskCompleteProgress(
                                                      item.taskList
                                                    ),
                                                }}
                                              ></div>
                                            </div>
                                          </td>
                                        </tr>
                                      );
                                    })}
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          </div>
                        )}
                      {/* {store.Role !== process.env.REACT_APP_ROLE_INSPECTION &&
                        store.Role !== process.env.REACT_APP_ROLE_SALLE &&
                        store.Role !== process.env.REACT_APP_ROLE_IT &&
                        store.Role !== process.env.REACT_APP_ROLE_AGRONOMIST &&
                        store.Role !== process.env.REACT_APP_ROLE_HR &&
                        store.Role !== process.env.REACT_APP_ROLE_JR_HR &&
                        store.Role !== process.env.REACT_APP_ROLE_ACCOUNTS &&
                        store.Role !== process.env.REACT_APP_ROLE_SSM && (
                          <div className="col-md-12 col-lg-8">
                            <div className="card">
                              <div className="card-header">
                                <h3 className="card-title">Leads summary</h3>

                                <div className="ms-auto lh-1">
                                  <div className="dropdown">
                                    <a
                                      className="dropdown-toggle text-muted"
                                      href="/"
                                      data-bs-toggle="dropdown"
                                      aria-haspopup="true"
                                      aria-expanded="false"
                                    >
                                      Last {leadsFrom || 30} days
                                    </a>
                                    <div className="dropdown-menu dropdown-menu-end">
                                      <span
                                        onClick={() => setLeadsFrom(7)}
                                        className="dropdown-item"
                                      >
                                        Last 7 days
                                      </span>
                                      <span
                                        onClick={() => setLeadsFrom(30)}
                                        className="dropdown-item"
                                      >
                                        Last 30 days
                                      </span>
                                      <span
                                        onClick={() => setLeadsFrom(45)}
                                        className="dropdown-item"
                                      >
                                        Last 45 days
                                      </span>
                                      <span
                                        onClick={() => setLeadsFrom(60)}
                                        className="dropdown-item"
                                      >
                                        Last 2 months
                                      </span>
                                      <span
                                        onClick={() => setLeadsFrom(90)}
                                        className="dropdown-item"
                                      >
                                        Last 3 months
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              {leadsData && leadsData.length > 0 && (
                                <Suspense fallback={<LoadingPage />}>
                                  <StackedBarChart
                                    leadsData={leadsData}
                                    leadsFrom={leadsFrom}
                                  />
                                </Suspense>
                              )}
                            </div>
                          </div>
                        )} */}
                      {store.Role !== process.env.REACT_APP_ROLE_ADMIN_S &&
                        store?.Role !== process.env.REACT_APP_ROLE_ACCOUNTS &&
                        store?.Role !==
                          process.env.REACT_APP_ROLE_MARKETING_AGENCY && (
                          <div className={ClassNameReturnAttendance()}>
                            <div
                              className="card"
                              style={{
                                backgroundColor: "rgb(178, 235, 242, 0.15)",
                              }}
                            >
                              <div className="card-header">
                                <h3 className="card-title">
                                  Attendance Summary
                                </h3>
                                <div className="ms-auto">
                                  <div className="d-flex">
                                    {(store.Role ===
                                      process.env.REACT_APP_ROLE_ADMIN ||
                                      store.Role ===
                                        process.env.REACT_APP_ROLE_ADMIN_S) && (
                                      <div className="me-2">
                                        <div className="dropdown">
                                          <a
                                            className="dropdown-toggle text-muted"
                                            href="/"
                                            data-bs-toggle="dropdown"
                                            aria-haspopup="true"
                                            aria-expanded="false"
                                          >
                                            {employeeName}
                                          </a>
                                          <div className="dropdown-menu dropdown-menu-end">
                                            <span
                                              onClick={() =>
                                                setEmployeeName("All")
                                              }
                                              className="dropdown-item"
                                            >
                                              All
                                            </span>
                                            {leadOwner &&
                                              leadOwner.map((data, index) => (
                                                <span
                                                  key={index}
                                                  onClick={() =>
                                                    setEmployeeName(
                                                      data.userName
                                                    )
                                                  }
                                                  className="dropdown-item"
                                                >
                                                  {data?.userName}
                                                </span>
                                              ))}
                                          </div>
                                        </div>
                                      </div>
                                    )}
                                    <div className="dropdown">
                                      <a
                                        className="dropdown-toggle text-muted"
                                        href="/"
                                        data-bs-toggle="dropdown"
                                        aria-haspopup="true"
                                        aria-expanded="false"
                                      >
                                        {months[selectedMonth].name}
                                      </a>
                                      <div className="dropdown-menu dropdown-menu-end">
                                        {months.map((month) => (
                                          <span
                                            key={month.value}
                                            onClick={() =>
                                              setSelectedMonth(month.value)
                                            }
                                            className="dropdown-item"
                                          >
                                            {month.name}
                                          </span>
                                        ))}
                                      </div>
                                    </div>
                                    <div className="dropdown ms-2 me-2">
                                      <a
                                        className="dropdown-toggle text-muted"
                                        href="/"
                                        data-bs-toggle="dropdown"
                                        aria-haspopup="true"
                                        aria-expanded="false"
                                      >
                                        {selectedYear}
                                      </a>
                                      <div className="dropdown-menu dropdown-menu-end">
                                        {years.map((year) => (
                                          <span
                                            key={year}
                                            onClick={() =>
                                              setSelectedYear(year)
                                            }
                                            className="dropdown-item"
                                          >
                                            {year}
                                          </span>
                                        ))}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              {leadOwner && attendanceData && (
                                <Suspense fallback={<LoadingPage />}>
                                  <AttendanceTracking
                                    leadOwner={leadOwner}
                                    attendanceData={attendanceData?.Attendance}
                                    attendanceFrom={selectedMonth}
                                    selectedYear={selectedYear}
                                  />
                                </Suspense>
                              )}
                            </div>
                          </div>
                        )}
                      {/* {store.Role !== process.env.REACT_APP_ROLE_SALESAGENCY &&
                        store.Role !== process.env.REACT_APP_ROLE_PURCHASE &&
                        store.Role !== process.env.REACT_APP_ROLE_AGRONOMIST &&
                        store.Role !== process.env.REACT_APP_ROLE_INSPECTION &&
                        store.Role !== process.env.REACT_APP_ROLE_IT &&
                        store?.Role !== process.env.REACT_APP_ROLE_SALLE && (
                          <div className="col-md-12 col-lg-8">
                            <div className="card">
                              <div className="card-header">
                                <h3 className="card-title">Enquiry summary</h3>

                                <div className="ms-auto lh-1">
                                  <div className="dropdown">
                                    <a
                                      className="dropdown-toggle text-muted"
                                      href="/"
                                      data-bs-toggle="dropdown"
                                      aria-haspopup="true"
                                      aria-expanded="false"
                                    >
                                      Last {enquiryFrom || 30} days
                                    </a>
                                    <div className="dropdown-menu dropdown-menu-end">
                                      <span
                                        onClick={() => setEnquiryFrom(7)}
                                        className="dropdown-item"
                                      >
                                        Last 7 days
                                      </span>
                                      <span
                                        onClick={() => setEnquiryFrom(30)}
                                        className="dropdown-item"
                                      >
                                        Last 30 days
                                      </span>
                                      <span
                                        onClick={() => setEnquiryFrom(45)}
                                        className="dropdown-item"
                                      >
                                        Last 45 days
                                      </span>
                                      <span
                                        onClick={() => setEnquiryFrom(60)}
                                        className="dropdown-item"
                                      >
                                        Last 2 months
                                      </span>
                                      <span
                                        onClick={() => setEnquiryFrom(90)}
                                        className="dropdown-item"
                                      >
                                        Last 3 months
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              {enquiryData && enquiryData.length > 0 && (
                                <Suspense fallback={<LoadingPage />}>
                                  <EnquiryChart
                                    enquiryData={enquiryData}
                                    enquiryFrom={enquiryFrom}
                                  />
                                </Suspense>
                              )}
                            </div>
                          </div>
                        )} */}
                      {store.Role !== process.env.REACT_APP_ROLE_PURCHASE &&
                        store.Role !== process.env.REACT_APP_ROLE_AGRONOMIST &&
                        store.Role !== process.env.REACT_APP_ROLE_INSPECTION &&
                        store.Role !== process.env.REACT_APP_ROLE_IT &&
                        store?.Role !== process.env.REACT_APP_ROLE_SALLE &&
                        store?.Role !==
                          process.env.REACT_APP_ROLE_SALLE_ADMIN &&
                        store?.Role !== process.env.REACT_APP_ROLE_HR &&
                        store?.Role !== process.env.REACT_APP_ROLE_JR_HR &&
                        store?.Role !== process.env.REACT_APP_ROLE_ACCOUNTS &&
                        store?.Role !== process.env.REACT_APP_ROLE_SSM &&
                        store?.Role !==
                          process.env.REACT_APP_ROLE_SALESCOORDINATOR &&
                        store?.Role !== process.env.REACT_APP_ROLE_MARKETING &&
                        store?.Role !==
                          process.env.REACT_APP_ROLE_OFFICE_STAFF &&
                        store?.Role !==
                          process.env.REACT_APP_ROLE_MARKETING_AGENCY && (
                          <div className={ClassNameSalesLeaderboard()}>
                            <div
                              className="card"
                              style={{
                                backgroundColor: "rgb(46, 204, 113, 0.15)",
                              }}
                            >
                              <div className="card-header">
                                <h3 className="card-title">
                                  Sales Leaderboard
                                </h3>
                              </div>
                              <Suspense fallback={<LoadingPage />}>
                                <LeaderBoard />
                              </Suspense>
                            </div>
                          </div>
                        )}
                      {(store.Role === process.env.REACT_APP_ROLE_ADMIN ||
                        store.Role === process.env.REACT_APP_ROLE_ADMIN_S ||
                        store.Role === process.env.REACT_APP_ROLE_HR ||
                        store.Role === process.env.REACT_APP_ROLE_JR_HR) && (
                        <div className={ClassNameReturnHrLeaves()}>
                          <div
                            className="card"
                            style={{
                              backgroundColor: "rgb(255, 105, 97, 0.15)",
                            }}
                          >
                            {/* <div className="card-header"> */}
                            <div className="card-header d-flex justify-content-between align-items-center">
                              <h3 className="card-title">Employee Leaves</h3>
                              <CustomViewButton
                                onClick={() => goToAllEmployeeLeaves()}
                                label="All Leaves"
                              ></CustomViewButton>
                            </div>
                            <div
                              className="card-table table-responsive"
                              style={{ maxHeight: "400px" }}
                            >
                              <table className="table table-vcenter">
                                <thead>
                                  <tr>
                                    <th
                                      style={{
                                        backgroundColor:
                                          "rgb(230, 230, 250, 0)",
                                      }}
                                    >
                                      Name
                                    </th>
                                    <th
                                      style={{
                                        backgroundColor:
                                          "rgb(230, 230, 250, 0)",
                                      }}
                                    >
                                      Date
                                    </th>
                                    <th
                                      style={{
                                        backgroundColor:
                                          "rgb(230, 230, 250, 0)",
                                      }}
                                    >
                                      Status
                                    </th>
                                    <th
                                      style={{
                                        backgroundColor:
                                          "rgb(230, 230, 250, 0)",
                                      }}
                                    >
                                      Actions
                                    </th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {sortedLeaveData?.map((item, index) => {
                                    return (
                                      <tr key={index}>
                                        <td>{item?.userName || "N/A"}</td>
                                        <td>
                                          {item?.leaveDate !== ""
                                            ? formatDate(item?.leaveDate)
                                            : item?.leaveStartDate !== ""
                                            ? formatDate(item?.leaveStartDate)
                                            : "N/A"}
                                        </td>
                                        <td>{item?.leaveStatus}</td>
                                        <td>
                                          {/* <button
                                              className="btn btn-primary"
                                              style={{
                                                width: "50px",
                                                height: "25px",
                                              }}
                                              onClick={() =>
                                                goToViewLeave(item?.userId)
                                              }
                                            >
                                              View
                                            </button> */}
                                          <CustomViewButton
                                            onClick={() =>
                                              goToViewLeave(item?.userId)
                                            }
                                          ></CustomViewButton>
                                        </td>
                                      </tr>
                                    );
                                  })}
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                      )}
                      {store.Role !== process.env.REACT_APP_ROLE_PURCHASE &&
                        store.Role !== process.env.REACT_APP_ROLE_AGRONOMIST &&
                        store.Role !== process.env.REACT_APP_ROLE_SALLE &&
                        store.Role !== process.env.REACT_APP_ROLE_SALLE_ADMIN &&
                        store.Role !== process.env.REACT_APP_ROLE_INSPECTION &&
                        store.Role !== process.env.REACT_APP_ROLE_IT &&
                        store.Role !==
                          process.env.REACT_APP_ROLE_CLIENT_FEEDBACK &&
                        store.Role !== process.env.REACT_APP_ROLE_ACCOUNTS &&
                        store.Role !== process.env.REACT_APP_ROLE_SSM &&
                        store?.Role !==
                          process.env.REACT_APP_ROLE_SALESCOORDINATOR &&
                        store?.Role !== process.env.REACT_APP_ROLE_MARKETING &&
                        store?.Role !==
                          process.env.REACT_APP_ROLE_OFFICE_STAFF &&
                        store?.Role !==
                          process.env.REACT_APP_ROLE_MARKETING_AGENCY && (
                          <>
                            {" "}
                            <div className="col-12 col-md-12 col-lg-12">
                              <div
                                className="card"
                                // style={{
                                //   backgroundColor: "rgb(243, 244, 246, 1)",
                                // }}
                              >
                                <div className="card-header">
                                  <h3 className="card-title">
                                    Lead Owners Summary
                                  </h3>

                                  <div className="ms-auto lh-1">
                                    <div className="dropdown">
                                      <a
                                        className="dropdown-toggle text-muted"
                                        href="/"
                                        data-bs-toggle="dropdown"
                                        aria-haspopup="true"
                                        aria-expanded="false"
                                      >
                                        {trackFrom === 0
                                          ? "Today"
                                          : trackFrom === -1
                                          ? "Yesterday"
                                          : `Last ${trackFrom || 30} days`}
                                      </a>
                                      <div className="dropdown-menu dropdown-menu-end">
                                        <span
                                          onClick={() => setTrackFrom(0)}
                                          className="dropdown-item"
                                        >
                                          Today
                                        </span>
                                        <span
                                          onClick={() => setTrackFrom(-1)}
                                          className="dropdown-item"
                                        >
                                          Yesterday
                                        </span>
                                        <span
                                          onClick={() => setTrackFrom(7)}
                                          className="dropdown-item"
                                        >
                                          Last 7 days
                                        </span>
                                        <span
                                          onClick={() => setTrackFrom(30)}
                                          className="dropdown-item"
                                        >
                                          Last 30 days
                                        </span>
                                        <span
                                          onClick={() => setTrackFrom(45)}
                                          className="dropdown-item"
                                        >
                                          Last 45 days
                                        </span>
                                        <span
                                          onClick={() => setTrackFrom(60)}
                                          className="dropdown-item"
                                        >
                                          Last 2 months
                                        </span>
                                        <span
                                          onClick={() => setTrackFrom(90)}
                                          className="dropdown-item"
                                        >
                                          Last 3 months
                                        </span>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                {
                                  <Suspense fallback={<LoadingPage />}>
                                    {/* <SalesWorkTracking trackFrom={trackFrom} /> */}
                                    <SalesDailyReport trackFrom={trackFrom} />
                                  </Suspense>
                                }
                              </div>
                            </div>
                            {/* {(store.Role === process.env.REACT_APP_ROLE_ADMIN ||
                              store.Role ===
                                process.env.REACT_APP_ROLE_ADMIN_S ||
                              store.Role === process.env.REACT_APP_ROLE_HR ||
                              store.Role ===
                                process.env.REACT_APP_ROLE_JR_HR) && (
                              <div className="col-12 col-md-4 col-lg-4">
                                <div
                                  className="card"
                                  style={{
                                    backgroundColor: "rgb(255, 159, 67, 0.15)",
                                  }}
                                >
                                  <div className="card-header">
                                    <h3 className="card-title">Missed Calls</h3>
                                  </div>
                                  <div
                                    className="card-table table-responsive"
                                    style={{ maxHeight: "400px" }}
                                  >
                                    <table className="table table-vcenter">
                                      <thead>
                                        <tr>
                                          <th
                                            style={{
                                              backgroundColor:
                                                "rgb(255, 159, 67, 0)",
                                            }}
                                          >
                                            Name
                                          </th>
                                         
                                          <th
                                            style={{
                                              backgroundColor:
                                                "rgb(255, 159, 67, 0)",
                                            }}
                                          >
                                            Pending Missed Calls
                                          </th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        {missedCall?.map((item, index) => {
                                          return (
                                            <tr key={index}>
                                              <td>
                                                {item?.assignedTo || "N/A"}
                                              </td>
                                             
                                              <td className="text-center">
                                                {item?.missedCallCount || "N/A"}
                                              </td>
                                            </tr>
                                          );
                                        })}
                                      </tbody>
                                    </table>
                                  </div>
                                </div>
                              </div>
                            )} */}
                          </>
                        )}

                      {store.Role !== process.env.REACT_APP_ROLE_PURCHASE &&
                        store.Role !== process.env.REACT_APP_ROLE_AGRONOMIST &&
                        store.Role !== process.env.REACT_APP_ROLE_SALLE &&
                        store.Role !== process.env.REACT_APP_ROLE_SALLE_ADMIN &&
                        store.Role !== process.env.REACT_APP_ROLE_INSPECTION &&
                        store.Role !== process.env.REACT_APP_ROLE_IT &&
                        store.Role !==
                          process.env.REACT_APP_ROLE_CLIENT_FEEDBACK &&
                        store.Role !== process.env.REACT_APP_ROLE_ACCOUNTS &&
                        store.Role !== process.env.REACT_APP_ROLE_SSM &&
                        store?.Role !==
                          process.env.REACT_APP_ROLE_SALESCOORDINATOR &&
                        store?.Role !== process.env.REACT_APP_ROLE_MARKETING &&
                        store?.Role !==
                          process.env.REACT_APP_ROLE_OFFICE_STAFF &&
                        store?.Role !==
                          process.env.REACT_APP_ROLE_MARKETING_AGENCY && (
                          <>
                            {" "}
                            <div className="col-12 col-md-12 col-lg-12">
                              <div
                                className="card"
                                // style={{
                                //   backgroundColor: "rgb(243, 244, 246, 1)",
                                // }}
                              >
                                <div className="card-header">
                                  <h3 className="card-title">
                                    Alpha Call Tracking
                                  </h3>

                                  <div className="ms-auto lh-1">
                                    <div className="dropdown">
                                      <a
                                        className="dropdown-toggle text-muted"
                                        href="/"
                                        data-bs-toggle="dropdown"
                                        aria-haspopup="true"
                                        aria-expanded="false"
                                      >
                                        {trackFrom === 0
                                          ? "Today"
                                          : trackFrom === -1
                                          ? "Yesterday"
                                          : `Last ${trackFrom || 30} days`}
                                      </a>
                                      <div className="dropdown-menu dropdown-menu-end">
                                        <span
                                          onClick={() =>
                                            setAlphaCallRecordsTrackFrom(1)
                                          }
                                          className="dropdown-item"
                                        >
                                          Today
                                        </span>
                                        <span
                                          onClick={() =>
                                            setAlphaCallRecordsTrackFrom(-1)
                                          }
                                          className="dropdown-item"
                                        >
                                          Yesterday
                                        </span>
                                        <span
                                          onClick={() =>
                                            setAlphaCallRecordsTrackFrom(7)
                                          }
                                          className="dropdown-item"
                                        >
                                          Last 7 days
                                        </span>
                                        <span
                                          onClick={() =>
                                            setAlphaCallRecordsTrackFrom(30)
                                          }
                                          className="dropdown-item"
                                        >
                                          Last 30 days
                                        </span>
                                        <span
                                          onClick={() =>
                                            setAlphaCallRecordsTrackFrom(45)
                                          }
                                          className="dropdown-item"
                                        >
                                          Last 45 days
                                        </span>
                                        <span
                                          onClick={() =>
                                            setAlphaCallRecordsTrackFrom(60)
                                          }
                                          className="dropdown-item"
                                        >
                                          Last 2 months
                                        </span>
                                        <span
                                          onClick={() =>
                                            setAlphaCallRecordsTrackFrom(90)
                                          }
                                          className="dropdown-item"
                                        >
                                          Last 3 months
                                        </span>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                {
                                  <Suspense fallback={<LoadingPage />}>
                                    {/* <SalesWorkTracking trackFrom={trackFrom} /> */}
                                    <AlphaDailyCallRecords
                                      alphaCallRecordsTrackFrom={
                                        alphaCallRecordsTrackFrom
                                      }
                                    />
                                  </Suspense>
                                }
                              </div>
                            </div>
                            {/* {(store.Role === process.env.REACT_APP_ROLE_ADMIN ||
                              store.Role ===
                                process.env.REACT_APP_ROLE_ADMIN_S ||
                              store.Role === process.env.REACT_APP_ROLE_HR ||
                              store.Role ===
                                process.env.REACT_APP_ROLE_JR_HR) && (
                              <div className="col-12 col-md-4 col-lg-4">
                                <div
                                  className="card"
                                  style={{
                                    backgroundColor: "rgb(255, 159, 67, 0.15)",
                                  }}
                                >
                                  <div className="card-header">
                                    <h3 className="card-title">Missed Calls</h3>
                                  </div>
                                  <div
                                    className="card-table table-responsive"
                                    style={{ maxHeight: "400px" }}
                                  >
                                    <table className="table table-vcenter">
                                      <thead>
                                        <tr>
                                          <th
                                            style={{
                                              backgroundColor:
                                                "rgb(255, 159, 67, 0)",
                                            }}
                                          >
                                            Name
                                          </th>
                                         
                                          <th
                                            style={{
                                              backgroundColor:
                                                "rgb(255, 159, 67, 0)",
                                            }}
                                          >
                                            Pending Missed Calls
                                          </th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        {missedCall?.map((item, index) => {
                                          return (
                                            <tr key={index}>
                                              <td>
                                                {item?.assignedTo || "N/A"}
                                              </td>
                                             
                                              <td className="text-center">
                                                {item?.missedCallCount || "N/A"}
                                              </td>
                                            </tr>
                                          );
                                        })}
                                      </tbody>
                                    </table>
                                  </div>
                                </div>
                              </div>
                            )} */}
                          </>
                        )}
                      {/* {store.Role !== process.env.REACT_APP_ROLE_PURCHASE &&
                        store.Role !== process.env.REACT_APP_ROLE_AGRONOMIST &&
                        store.Role !== process.env.REACT_APP_ROLE_INSPECTION &&
                        store.Role !== process.env.REACT_APP_ROLE_IT && (
                          <div className="col-12">
                            <div className="card">
                              <div className="card-header">
                                <h3 className="card-title">
                                  Sales daily updates
                                </h3>
                                <div className="ms-auto">
                                  <div className="d-flex">
                                    {store.Role !==
                                      process.env.REACT_APP_ROLE_SALLE &&
                                      store.Role !==
                                        process.env
                                          .REACT_APP_ROLE_SALESAGENCY && (
                                        <div className="me-2">
                                          <div className="dropdown">
                                            <a
                                              className="dropdown-toggle text-muted"
                                              href="/"
                                              data-bs-toggle="dropdown"
                                              aria-haspopup="true"
                                              aria-expanded="false"
                                            >
                                              {employee}
                                            </a>
                                            <div className="dropdown-menu dropdown-menu-end">
                                              <span
                                                onClick={() =>
                                                  setEmployee("All")
                                                }
                                                className="dropdown-item"
                                              >
                                                All
                                              </span>
                                              {leadOwner &&
                                                leadOwner.map((data, index) => {
                                                  return (
                                                    <span
                                                      key={index}
                                                      onClick={() =>
                                                        setEmployee(
                                                          data.userName
                                                        )
                                                      }
                                                      className="dropdown-item"
                                                    >
                                                      {data?.userName}
                                                    </span>
                                                  );
                                                })}
                                            </div>
                                          </div>
                                        </div>
                                      )}
                                    <div className="dropdown">
                                      <a
                                        className="dropdown-toggle text-muted"
                                        href="/"
                                        data-bs-toggle="dropdown"
                                        aria-haspopup="true"
                                        aria-expanded="false"
                                      >
                                        Last {leadsFrom || 30} days
                                      </a>
                                      <div className="dropdown-menu dropdown-menu-end">
                                        <span
                                          onClick={() => setLeadsFrom(7)}
                                          className="dropdown-item"
                                        >
                                          Last 7 days
                                        </span>
                                        <span
                                          onClick={() => setLeadsFrom(30)}
                                          className="dropdown-item"
                                        >
                                          Last 30 days
                                        </span>
                                        <span
                                          onClick={() => setLeadsFrom(45)}
                                          className="dropdown-item"
                                        >
                                          Last 45 days
                                        </span>
                                        <span
                                          onClick={() => setLeadsFrom(60)}
                                          className="dropdown-item"
                                        >
                                          Last 2 months
                                        </span>
                                        <span
                                          onClick={() => setLeadsFrom(90)}
                                          className="dropdown-item"
                                        >
                                          Last 3 months
                                        </span>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              {leadsData &&
                                quotationData &&
                                quotationData.length > 0 &&
                                leadsData.length > 0 && (
                                  <LineChart
                                    leadsData={leadsData}
                                    quotationData={quotationData}
                                    leadsFrom={leadsFrom}
                                    employee={employee}
                                  />
                                )}
                            </div>
                          </div>
                        )} */}
                      {/* {store.Role !== process.env.REACT_APP_ROLE_PURCHASE &&
                        store.Role !== process.env.REACT_APP_ROLE_AGRONOMIST &&
                        store.Role !==
                          process.env.REACT_APP_ROLE_INSPECTION && (
                          <div className="col-lg-6">
                            <div className="card">
                              <div className="card-header">
                                <h3 className="card-title">
                                  Attendance summary
                                </h3>
                                {store?.Role !==
                                  process.env.REACT_APP_ROLE_SALLE &&
                                  store?.Role !==
                                    process.env.REACT_APP_ROLE_SALESAGENCY && (
                                    <div className="ms-auto me-3 lh-1">
                                      <div className="dropdown">
                                        <a
                                          className="dropdown-toggle text-muted"
                                          href="/"
                                          data-bs-toggle="dropdown"
                                          aria-haspopup="true"
                                          aria-expanded="false"
                                        >
                                          {employeeName}
                                        </a>
                                        <div className="dropdown-menu dropdown-menu-end">
                                          {leadOwner &&
                                            leadOwner.map((data, index) => {
                                              return (
                                                <span
                                                  key={index}
                                                  onClick={() =>
                                                    setEmployeeName(
                                                      data.userName
                                                    )
                                                  }
                                                  className="dropdown-item"
                                                >
                                                  {data?.userName}
                                                </span>
                                              );
                                            })}
                                        </div>
                                      </div>
                                    </div>
                                  )}
                                <div
                                  className={
                                    store?.Role ==
                                      process.env.REACT_APP_ROLE_SALLE ||
                                    store?.Role ==
                                      process.env.REACT_APP_ROLE_SALESAGENCY
                                      ? "ms-auto lh-1"
                                      : "lh-1"
                                  }
                                >
                                  <div className="dropdown">
                                    <a
                                      className="dropdown-toggle text-muted"
                                      href="/"
                                      data-bs-toggle="dropdown"
                                      aria-haspopup="true"
                                      aria-expanded="false"
                                    >
                                      {attendanceFrom === 0
                                        ? "Today"
                                        : `Last ${attendanceFrom || 7} days`}
                                    </a>
                                    <div className="dropdown-menu dropdown-menu-end">
                                      <span
                                        onClick={() => setAttendanceFrom(7)}
                                        className="dropdown-item"
                                      >
                                        Last 7 days
                                      </span>
                                      <span
                                        onClick={() => setAttendanceFrom(30)}
                                        className="dropdown-item"
                                      >
                                        Last 30 days
                                      </span>
                                      <span
                                        onClick={() => setAttendanceFrom(45)}
                                        className="dropdown-item"
                                      >
                                        Last 45 days
                                      </span>
                                      <span
                                        onClick={() => setAttendanceFrom(60)}
                                        className="dropdown-item"
                                      >
                                        Last 2 months
                                      </span>
                                      <span
                                        onClick={() => setAttendanceFrom(90)}
                                        className="dropdown-item"
                                      >
                                        Last 3 months
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              {attendanceData &&
                                attendanceData?.Attendance &&
                                attendanceFrom && (
                                  <AttendanceChart
                                    attendanceFrom={attendanceFrom}
                                    attendance={attendanceData?.Attendance}
                                  />
                                )}
                            </div>
                          </div>
                        )}

                      <div
                        className="col-lg-6"
                        data-bs-toggle="modal"
                        data-bs-target="#modalScrollable"
                        style={{ cursor: "pointer" }}
                      >
                        <embed
                          src={`https://res.cloudinary.com/dph1m5tq7/image/upload/v1733112094/Kryzen38Days_compressed_r9icjz.pdf`}
                          width="100%"
                          height="100%"
                          type="application/pdf"
                          data-bs-toggle="modal"
                          data-bs-target="#modalScrollable"
                        />
                      </div>

                      <div
                        className="modal fade"
                        id="modalScrollable"
                        tabIndex="-1"
                        role="dialog"
                        aria-labelledby="modalScrollableTitle"
                        aria-hidden="true"
                      >
                        <div
                          className="modal-dialog modal-dialog-centered"
                          role="document"
                        >
                          <div className="modal-content">
                            <div className="modal-header">
                              <h5
                                className="modal-title"
                                id="modalScrollableTitle"
                              >
                                38 Rules of Rewiring for Kryzen
                              </h5>
                              <button
                                type="button"
                                className="btn-close"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                              ></button>
                            </div>
                            <div className="modal-body">
                              <embed
                                src={`https://res.cloudinary.com/dph1m5tq7/image/upload/v1733112094/Kryzen38Days_compressed_r9icjz.pdf`}
                                width="100%"
                                height="400px"
                                type="application/pdf"
                                style={{ border: "none" }}
                              />
                            </div>
                            <div className="modal-footer">
                              <button
                                type="button"
                                className="btn btn-secondary"
                                data-bs-dismiss="modal"
                              >
                                Close
                              </button>
                            </div>
                          </div>
                        </div>
                      </div> */}
                      {store?.Role !==
                        process.env.REACT_APP_ROLE_MARKETING_AGENCY && (
                        <div className="col-lg-6 col-md-12">
                          <div
                            className="card"
                            style={{
                              backgroundColor: "rgb(100, 149, 237, 0.12)",
                            }}
                          >
                            <div className="card-header">
                              <h3 className="card-title">
                                <FcRules className="fs-2 me-1" /> Attendance
                                Policy
                              </h3>
                            </div>
                            <div className="card-body">
                              <ul>
                                <li className="m-1">
                                  Your working hours start at 09:00AM and finish
                                  at 06:00PM.
                                </li>
                                <li className="m-1">
                                  You have a lunch break from 01:30 PM to 02:15
                                  PM, followed by a 15-minute refreshment break
                                  at 04:00 PM.
                                </li>
                                <li className="m-1">
                                  You are expected to login at 09:00AM. In some
                                  situations, you can redeem a grace period of
                                  10 minutes.
                                </li>
                                <li className="m-1">
                                  Any login after 09:10AM will be considered as
                                  ‘Late Coming’.
                                </li>
                                <li className="m-1">
                                  On 3 Late Comings, half day salary will be
                                  deducted.
                                </li>
                                <li className="m-1">
                                  You are expected to contribute 09 hours to
                                  work every day.
                                </li>
                                <li className="m-1">
                                  Logging off before 09 hours will be considered
                                  as ‘Half Day’.
                                </li>
                                <li className="m-1">
                                  If you do not log out, it will be considered
                                  as a 'Full Day' Off.
                                </li>
                                <li className="m-1">
                                  All salary calculations are automated based on
                                  the above rules.
                                </li>

                                <li>
                                  Not adhering to above attendance rules may
                                  result in warning for disciplinary action.
                                </li>
                                <li className="m-1">
                                  KBPL is an equal opportunity and unbiased
                                  organization. The rules are applicable to
                                  everyone unless otherwise stated in writing by
                                  management.
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                      )}
                      {store?.Role !==
                        process.env.REACT_APP_ROLE_MARKETING_AGENCY && (
                        <div className="col-lg-6 col-md-12">
                          <div
                            className="card"
                            style={{
                              backgroundColor: "rgb(100, 149, 237, 0.12)",
                            }}
                          >
                            <div className="card-header">
                              <h3 className="card-title">
                                <FcRules className="fs-2 me-1" /> Leave Policy
                              </h3>
                            </div>
                            <div className="card-body">
                              <ul>
                                <li className="m-1">
                                  When you are in probation or in notice period;
                                  all leaves will be unpaid.
                                </li>
                                <li className="m-1">
                                  All confirmed employees are entitled to a
                                  total of 15 leaves per calendar year devided
                                  in quarters as Q1:3leaves, Q2:4leaves,
                                  Q3:4leaves, Q4:4leaves.
                                </li>
                                {/* <li className="m-1">
                                Leave allocation is structured on a quarterly
                                basis as
                                <ul>
                                  <li>1st Quarter :- 3 leaves</li>
                                  <li>2nd Quarter :- 4 leaves</li>
                                  <li>3rd Quarter :- 4 leaves</li>
                                  <li>4th Quarter :- 4 leaves</li>
                                </ul>
                              </li> */}
                                <li className="m-1">
                                  You must submit a leave application at least 3
                                  days in advance for planned leaves using leave
                                  management system.
                                </li>
                                <li className="m-1">
                                  Not utilising the leave management system will
                                  result in deduction of additional one day of
                                  pay for total number of leaves taken.
                                </li>
                                <li className="m-1">
                                  Approval of leaves is subject to the
                                  discretion of the higher authority and the
                                  department needs.
                                </li>
                                <li className="m-1">
                                  You can choose to work on additional days in
                                  any calendar year. And get comp-off against
                                  it.
                                </li>
                                <li className="m-1">
                                  Comp off leaves are mandatory to apply in
                                  leave management system.
                                </li>
                                <li className="m-1">
                                  In a month you can not avail more then 3
                                  comp-off leaves.
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
              <Footer />
            </div>
          </div>
        )}

      <button
        className="btn"
        data-bs-toggle="modal"
        data-bs-target="#modal-simple"
        style={{ display: "none" }}
        id="openmodel"
      >
        Simple modal
      </button>

      <div
        className="modal modal-blur fade"
        id="modal-simple"
        tabIndex="-1"
        aria-hidden="true"
        style={{ display: "none" }}
      >
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Notifications</h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                id="closemodel"
              ></button>
            </div>
            <div className="modal-body">
              <h3>Pending Tasks ({taskData?.length || 0})</h3>
              {taskData?.length > 0 ? (
                <div className="col-12">
                  <div
                    className="card-table table-responsive"
                    style={{ maxHeight: "470px" }}
                  >
                    <table className="table table-vcenter">
                      <tbody>
                        {taskData?.map((task) => (
                          <tr key={task.id}>
                            <td>{task?.name}</td>
                            <td>
                              {task?.status === "pending" ? (
                                <span
                                  className="badge bg-orange"
                                  style={{ color: "white" }}
                                >
                                  Pending
                                </span>
                              ) : (
                                <span
                                  className="badge bg-green"
                                  style={{ color: "white" }}
                                >
                                  Completed
                                </span>
                              )}
                            </td>
                            <td>{task?.deadline || "N/A"}</td>
                            <td>{task?.taskType || "N/A"}</td>
                            <td>
                              <button
                                data-bs-dismiss="modal"
                                className="btn btn-primary"
                                style={{
                                  width: "50px",
                                  height: "25px",
                                }}
                                onClick={() => goToViewTaks(task?.id)}
                              >
                                View
                              </button>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              ) : (
                <p>Hurray! No pending tasks for today! 🎉</p>
              )}
              {store?.DaysRemainingToUpdatePassword && (
                <>
                  <hr />
                  <h3>Password Update Warning!!!</h3>
                  <p>Your password need to be update. please update it.</p>
                  <button
                    type="button"
                    className="btn btn-link link-secondary me-auto"
                    data-bs-dismiss="modal"
                  >
                    Remind Me Leter
                  </button>
                  <button
                    type="button"
                    className="btn btn-primary"
                    data-bs-dismiss="modal"
                    onClick={() => navigate("reset-password")}
                  >
                    Update Password
                  </button>
                </>
              )}
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn me-auto"
                data-bs-dismiss="modal"
                id="closemodel"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* reset password modal */}
      <button
        className="btn"
        data-bs-toggle="modal"
        data-bs-target="#modal-small"
        style={{ display: "none" }}
        id="openresetpasswordmodal"
      >
        Simple modal
      </button>
      <div
        className="modal modal-blur fade"
        id="modal-small"
        tabIndex="-1"
        role="dialog"
        aria-hidden="true"
      >
        <div
          className="modal-dialog modal-sm modal-dialog-centered"
          role="document"
        >
          <div className="modal-content">
            <div className="modal-body">
              <div className="modal-title">Update password</div>
              <div>Your password need to be update. please update it.</div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-link link-secondary me-auto"
                data-bs-dismiss="modal"
              >
                Remind Me Leter
              </button>
              <button
                type="button"
                className="btn btn-primary"
                data-bs-dismiss="modal"
                onClick={() => navigate("reset-password")}
              >
                Update Password
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Dashbourd;
